<template>
  <div class="side">
    <!-- 导航收缩图标 -->
    <div @click="isCollapse = !isCollapse" class="expandIcon">
      <i class="i ixiangyouzhankai sideIcon"> </i>
    </div>
    <!-- https://studio.glassnode.com/images/crypto-icons/eth.png -->
    <!-- 币种切换 -->
    <div class="currency">
      <div class="currencySwitching">
        <div @click="handelChang(`BTC`)">
          <img
            style="width: 20px"
            src=".././assets/nav_images/btc .png"
            alt=""
          />
          <span :class="{ active: BTCisActive }">BTC</span>
        </div>
        <!-- <div @click="handelChang(`ETH`)">
          <img
            style="width: 20px"
            src="../assets/nav_images/eth .png"
            alt=""
          />
          <span :class="{ active: ETHisActive }">ETH</span>
        </div> -->
        <!-- 稳定币和下拉币种 -->

        <div @click="handelChang(`稳定币`)" >
          <img
            style="width: 20px"
            src="../assets/nav_images/usdc .png"
            alt=""
          />
          <span :class="{ active: WisActive }">
            {{ $t(`menu.Stablecoin`) }}</span
          >
        </div>
        <!-- 宏观经济 -->
        <!-- <div @click="handelChang(`menu.macroscopic`)" id="Stablecoin">
        
          <span :class="{ active: macroscopicActive }">
            {{ $t(`menu.macroscopic`) }}</span
          >
        </div> -->

        <!-- 下拉币种 其他-->
        <div class="other">
          <el-dropdown
            class="drop-down"
            style="height: 40%"
            @command="handelItem"
            trigger="click"
            :modal-append-to-body="true"
          >
            <span class="el-dropdown-link">
              {{ $t(`menu.other`) }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu2">
              <el-dropdown-item
                @click.native="handelChang(item.label)"
                v-for="item in DropdownMenu"
                :key="item.value"
                :command="item.label"
                >{{ $t(item.label) }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <!-- ------------搜索框----------------- -->
    <div
      v-show="!isCollapse"
      :class="{ querySearch: !isCollapse, noQueryShow: isCollapse }"
    >
      <i class="el-icon-search searchIcon" @click="handleSelect"></i>
      <div class="starBox">
        <i
          v-if="starsNum >= 1"
          class="el-icon-circle-close close"
          @click="handelIconClose"
        ></i>
        <i v-if="starsNum >= 1" class="i ixingxing star"></i>
        <i v-if="starsNum >= 2" class="i ixingxing star"></i>
        <i v-if="starsNum >= 3" class="i ixingxing star"></i>
      </div>

      <el-autocomplete
        v-model="state"
        :fetch-suggestions="querySearchAsync"
        :placeholder="$t(`login.navigation`)"
        @select="handleSelect"
        @keydown.enter.native="handleSelect"
      >
        <template slot-scope="{ item }">
          <span>
            <div v-if="item.address === `S-3`">
              <i class="i ixingxing star"></i>
            </div>
            <div v-if="item.address === `S-2`">
              <i class="i ixingxing star"></i>
              <i class="i ixingxing star"></i>
            </div>
            <!-- <div v-if="item.address === `S-1`">
          <i  class="i ixingxing star"></i>
          <i  class="i ixingxing star"></i>
          <i  class="i ixingxing star"></i>
        </div> -->

            {{ item.value }}
          </span>
        </template>
      </el-autocomplete>
    </div>
    <!-- 更新内容 -->
    <div class="updateBox" @click="handelUpdateContent"  v-show="roleKey==`admin`">
      <i class="i izixun3"></i>
      <p  v-show="!isCollapse"   :class="{update:!UpdateState,updateBoxActive:UpdateState}">{{ $t(`home.updateContent`) }}</p>
    </div>

    <el-menu
      :default-active="open"
      router:true
      mode="vertical"
      class="el-menu-vertical-demo"
      text-color="#000"
      :collapse="isCollapse"
      menu-trigger="click"
    >
      <el-submenu
        :index="item.id"
        v-for="item in asideMenu"
        :key="item.id"
        :title="$t(item.label)"
      >
        <template slot="title">
          <i :class="item.icon"></i>
          <span class="content" :title="$t(item.label)">{{
            $t(item.label)
          }}</span>
        </template>
        <!-- 单层菜单 -->
        <div v-for="item1 in item.children" :key="item1.id">
          <el-menu-item
            class="menuItem"
            @click="handelClick(item1)"
            :index="item1.id"
            v-if="!item1.children"
            :title="$t(item1.label)"
            popper-class="menu-item-hidden"
          >
            <!-- <span
              :class="[
                { typeStyleT1: item1.type == `L1` },
                { typeStyleT2: item1.type == `L2` },
                { typeStyleT3: item1.type == `L3` },
              ]"
              >{{ item1.type }}</span
            > -->
            <div class="navItem">
              <el-rate
                disabled
                v-model="starObj[item1.type]"
                :max="max"
                disabled-void-color="rgba(0,0,0,0.3)"
                :colors="['#f7931a', '#f7931a', '#f7931a']"
                score-template="{value}"
              >
              </el-rate>
              <div class="scrolling-textBox">
                <span class="scrolling-text"> {{ $t(item1.label) }}</span>
               </div>
            </div>
          </el-menu-item>
          <!-- 多层菜单 -->

          <el-submenu
            v-if="item1.children"
            :index="item1.id"
            :title="$t(item1.label)"
          >
            <template slot="title">
              <i :class="item1.icon"></i>
              <span class="content1" :title="$t(item1.label)">{{
                $t(item1.label)
              }}</span>
            </template>
            <div v-for="item2 in item1.children" :key="item2.id">
              <template v-if="!item2.children">
                <!-- v-for="item2 in item1.children"
              :key="item2.id"
              :index="item2.id" -->
                <el-menu-item
                  class="menuItem"
                  @click="handelClick(item2)"
                  :index="item2.id"
                  :title="$t(item2.label)"
                >
                  <!-- <span
             
                :class="[
                  { typeStyleT1: item2.type == `L1` },
                  { typeStyleT2: item2.type == `L2` },
                  { typeStyleT3: item2.type == `L3` },
                ]"
                >{{ item2.type }}</span
              > -->
                  <div class="navItem">
                    <el-rate
                      disabled
                      v-model="starObj[item2.type]"
                      :max="max"
                      disabled-void-color="rgba(0,0,0,0.3)"
                      :colors="['#f7931a', '#f7931a', '#f7931a']"
                      score-template="{value}"
                    >
                    </el-rate>
                    <div class="scrolling-textBox">
                    <span class="scrolling-text">{{ $t(item2.label) }}</span>
                  </div>
                  </div>
                </el-menu-item>
              </template>
              <!-- 第三层 -->
              <el-submenu
                v-if="item2.children"
                :index="item2.id"
                :title="$t(item2.label)"
              >
                <template slot="title">
                  <i :class="item2.icon"></i>
                  <span class="content1" :title="$t(item2.label)">{{
                    $t(item2.label)
                  }}</span>
                </template>

                <el-menu-item
                  class="menuItem"
                  @click="handelClick(item3)"
                  v-for="item3 in item2.children"
                  :key="item3.id"
                  :index="item3.id"
                  :title="$t(item3.label)"
                >
                  <!-- <span
                :class="[
                  { typeStyleT1: item3.type == `L1` },
                  { typeStyleT2: item3.type == `L2` },
                  { typeStyleT3: item3.type == `L3` },
                ]"
                >{{ item3.type }}</span
              > -->
                  <div class="navItem">
                    <el-rate
                      disabled
                      v-model="starObj[item3.type]"
                      :max="max"
                      disabled-void-color="rgba(0,0,0,0.3)"
                      :colors="['#f7931a', '#f7931a', '#f7931a']"
                      score-template="{value}"
                    >
                    </el-rate>

                    <span class="scrolling-text"> {{ $t(item3.label) }}</span>
                  </div>
                </el-menu-item>
              </el-submenu>
            </div>
          </el-submenu>
        </div>
      </el-submenu>
    </el-menu>

    <!-- 权限提示页面遮罩 --> 
    <!-- <div class="loginMain" v-show="lgMask">
      <el-row>
        <el-col :span="24">
          <p>
           
            {{ $t(`login.PagePermission`) }},
          </p>
          <div class="lodinMaskBox">
            <el-tag
              type="success"
              @click="handelUpgradeAccount"
              class="clickTag"  
              >{{ $t(lgMaskText) }}</el-tag
            >
        
          </div>
        </el-col>
      </el-row>
    </div> -->
  </div>
</template>

<script>
// import { Message } from "element-ui";
import { bTCMenu } from "../util/menu";
export default {
  data() {
    return {
      UpdateState:"",
      isCollapse: false,
      BTCisActive: false,
      ETHisActive: false,
      WisActive: false,
      macroscopicActive: false,
      dialogVisible: true,
      lgMask: false,
      asideMenu: [],
      //util中btcMenu需要同步更新
      BTCMenu: [
        {
          //链上数据
          label: "menu.onchain",
          icon: "i itubiao2",
          nested: "peers", //没有多层嵌套
          id: "B01",
          children: [
            {
              //地址
              label: "menu.address",
              icon: "i izhexiantu-xianxing",
              id: "B01-1",
              children: [
                {
                  //地址统计
                  path: "/",
                  label: "menu.onchain2",
                  fullName: "menu.onchain2",
                  icon: "i igl-folderOpen",
                  componentReq: "newAddress2",
                  radius: "btc",
                  id: "B01-1-4",
                  introduce: "introduce.address",
                  navigation: "newAddress",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest", //匿名用户
                },
                {
                  //盈利地址数
                  path: "/",
                  label: "menu.profitAddress",
                  fullName: "menu.profitAddress",
                  icon: "i igl-folderOpen",
                  componentReq: "profitAddress",
                  radius: "btc",
                  id: "B01-1-1",
                  introduce: "introduce.profitAddress",
                  navigation: "profitAddress",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance", //匿名用户
                },
                {
                  //亏损地址数
                  path: "/",
                  label: "menu.lossAddress",
                  fullName: "menu.lossAddress",
                  icon: "i igl-folderOpen",
                  componentReq: "lossAddress",
                  radius: "btc",
                  id: "B01-1-2",
                  introduce: "introduce.lossAddress",
                  navigation: "lossAddress",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance", //匿名用户
                },
                {
                  //地址盈亏比
                  path: "/",
                  label: "menu.profitRatio",
                  fullName: "menu.profitRatio",
                  icon: "i igl-folderOpen",
                  componentReq: "profitRatio",
                  radius: "btc",
                  id: "B01-1-3",
                  introduce: "introduce.profitRatio",
                  navigation: "profitRatio",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance", //匿名用户
                },

                {
                  //暂时注释 持有比特币超过100个的地址列表 改为 巨鲸地址列表 无权限
                  path: "/",
                  label: "menu.onchain15",
                  fullName: "menu.onchain15",
                  icon: "i igl-folderOpen",
                  componentReq: "getTopList",
                  radius: "btc",
                  id: "B01-1-5",
                  introduce: "introduce.getTopList",
                  navigation: "topList", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                {
                  //新增地址数
                  path: "/",
                  label: "menu.newAddress",
                  fullName: "menu.newAddress",
                  icon: "i igl-folderOpen",
                  componentReq: "newAddress2",
                  radius: "btc",
                  id: "B01-1-6",
                  introduce: "introduce.address",
                  navigation: "newAddress2",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest", //匿名用户
                },
                {
                  //新地址交易量
                  path: "/",
                  label: "menu.newAddressVolume",
                  fullName: "menu.newAddressVolume",
                  icon: "i igl-folderOpen",
                  componentReq: "newAddress2",
                  radius: "btc",
                  id: "B01-1-7",
                  introduce: "introduce.address",
                  navigation: "newAddressVolume",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest", //匿名用户
                },
                {
                  //总地址数
                  path: "/",
                  label: "menu.totalAddress",
                  fullName: "menu.totalAddress",
                  icon: "i igl-folderOpen",
                  componentReq: "newAddress2",
                  radius: "btc",
                  id: "B01-1-8",
                  introduce: "introduce.address",
                  navigation: "totalAddress",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest", //匿名用户
                },
              ],
            },
            {
              //矿工
              label: "menu.Miners",
              icon: "i izhexiantu-xianxing",
              id: "B02-1",
              children: [
                {
                  //发行价值（USD) 改为日发行价值 中英文都是 puell multiple  Puell Multiple
                  path: "/",
                  label: "menu.technology38",
                  fullName: "menu.technology38",
                  icon: "i igl-folderOpen",
                  componentReq: "mintusd",
                  radius: "btc",
                  id: "B02-1-1",
                  introduce: "introduce.mintusd",
                  navigation: "mintusd", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest", //匿名用户"
                },
                // {
                //   //矿工地址数 与矿工地址余额 合并 改为矿工余额
                //   path: "/",
                //   label: "menu.onchain20",
                //   fullName: "menu.onchain21",
                //   icon: "i igl-folderOpen",
                //   componentReq: "minerAddress",
                //   radius: "btc",
                //   id: "B02-1-2",
                //   introduce: "introduce.minerAddress",
                //   navigation: "minerAddress", //导航组件名称
                //   assets: "BTC",
                //   interval: "menu.interval3", //1天
                //   type: "L1",
                //   authority: "guest", //匿名用户
                // },
                {
                  //矿工地址数
                  path: "/",
                  label: "menu.minerAddress",
                  fullName: "menu.minerAddress",
                  icon: "i igl-folderOpen",
                  componentReq: "minerAddress",
                  radius: "btc",
                  id: "B02-1-3",
                  introduce: "introduce.minerAddress",
                  navigation: "minerAddress2", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3", //1天
                  type: "L1",
                  authority: "guest", //匿名用户
                },
                {
                  //矿工地址余额
                  path: "/",
                  label: "menu.minerBalance",
                  fullName: "menu.minerBalance",
                  icon: "i igl-folderOpen",
                  componentReq: "minerAddress",
                  radius: "btc",
                  id: "B02-1-4",
                  introduce: "introduce.minerAddress",
                  navigation: "minerBalance2", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3", //1天
                  type: "L1",
                  authority: "guest", //匿名用户
                },
              ],
            },
            {
              //网络
              label: "menu.Network",
              icon: "i izhexiantu-xianxing",
              id: "B03-1",
              children: [
                // {
                //   //日交易统计 更改名字 交易统计 拆分为 交易量、交易费、交易量(找零消除)
                //   path: "/",
                //   label: "menu.onchain19",
                //   fullName: "menu.onchain19",
                //   icon: "i igl-folderOpen",
                //   componentReq: "BTCVolume",
                //   radius: "btc",
                //   id: "B03-1-1",
                //   introduce: "introduce.BTCVolume",
                //   navigation: "volume", //导航组件名称
                //   assets: "BTC、ETH",
                //   interval: "menu.interval3",
                //   type: "L1",
                //   authority: "guest", //匿名用户
                // },
                {
                  //交易汇率乘数
                  path: "/",
                  label: "menu.frm",
                  fullName: "menu.frm",
                  icon: "i igl-folderOpen",
                  componentReq: "frm",
                  radius: "btc",
                  id: "B03-1-2",
                  introduce: "introduce.frm",
                  navigation: "frm",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
                {
                  //流通供应量
                  path: "/",
                  label: "menu.technology21",
                  fullName: "menu.technology21",
                  icon: "i igl-folderOpen",
                  componentReq: "csupply",
                  radius: "btc",
                  id: "B03-1-3",
                  introduce: "introduce.csupply",
                  navigation: "csupply", //导航组件名称
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest", //匿名用户
                },
                {
                  path: "/", //大额交易
                  label: "menu.onchain1",
                  fullName: "menu.onchain1",
                  icon: "i igl-folderOpen",
                  componentReq: "ethbigtxcount",
                  radius: "btc",
                  id: "B03-1-4",
                  introduce: "introduce.btcbigtxcount",
                  navigation: "bigDeals",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest", //匿名用户
                },
                // {
                //   //待交易池详情 拆分为交易内存池数量、交易内存池费用
                //   path: "/",
                //   label: "menu.mempool",
                //   fullName: "menu.mempool", //全名
                //   icon: "i igl-folderOpen",
                //   componentReq: "mempool",
                //   radius: "btc",
                //   id: "B03-1-5",
                //   introduce: "introduce.mempool",
                //   navigation: "mempool", //导航组件名称
                //   assets: "BTC",
                //   interval: "menu.interval3",
                //   type: "L2",
                //   authority: "registered",
                // },
                {
                  //交易量
                  path: "/",
                  label: "menu.TransactionVolume",
                  fullName: "menu.TransactionVolume",
                  icon: "i igl-folderOpen",
                  componentReq: "BTCVolume",
                  radius: "btc",
                  id: "B03-1-6",
                  introduce: "introduce.BTCVolume",
                  navigation: "TransactionVolume", //导航组件名称
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest", //匿名用户
                },
                {
                  //交易费
                  path: "/",
                  label: "menu.TransactionFee",
                  fullName: "menu.TransactionFee",
                  icon: "i igl-folderOpen",
                  componentReq: "BTCVolume",
                  radius: "btc",
                  id: "B03-1-7",
                  introduce: "introduce.BTCVolume",
                  navigation: "TransactionFee", //导航组件名称
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest", //匿名用户
                },
                {
                  //交易量(找零消除)
                  path: "/",
                  label: "menu.adjusted",
                  fullName: "menu.adjusted",
                  icon: "i igl-folderOpen",
                  componentReq: "BTCVolume",
                  radius: "btc",
                  id: "B03-1-8",
                  introduce: "introduce.BTCVolume",
                  navigation: "adjusted", //导航组件名称
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest", //匿名用户
                },
                {
                  //交易内存池数量 memoryPoolFees
                  path: "/",
                  label: "menu.TransactionCount",
                  fullName: "menu.TransactionCount", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "mempool",
                  radius: "btc",
                  id: "B03-1-9",
                  introduce: "introduce.mempool",
                  navigation: "TransactionCount", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
                {
                  //交易内存池费用 
                  path: "/",
                  label: "menu.memoryPoolFees",
                  fullName: "menu.memoryPoolFees", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "mempool",
                  radius: "btc",
                  id: "B03-1-10",
                  introduce: "introduce.mempool",
                  navigation: "memoryPoolFees", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
              ],
            },
            {
              //长/短期持有者
              label: "menu.LongShort",
              icon: "i izhexiantu-xianxing",
              id: "B04-1",
              children: [
                {
                  //长期持有者每日交易量
                  path: "/",
                  label: "menu.lthVolume", //简写
                  fullName: "menu.lthVolume2", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "lthVolume",
                  radius: "btc",
                  id: "B04-1-1",
                  introduce: "introduce.lthVolume",
                  navigation: "lthVolume",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance",
                },
                {
                  //长期持有者供应量
                  path: "/",
                  label: "menu.lthSupply",
                  fullName: "menu.lthSupply2", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "lthSupply",
                  radius: "btc",
                  id: "B04-1-2",
                  introduce: "introduce.lthSupply",
                  navigation: "lthSupply",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance",
                },
                {
                  //长期持有者盈利总供应量 改为 长期持有者盈利供应量
                  path: "/",
                  label: "menu.lthProfitSupply",
                  fullName: "menu.lthProfitSupply2", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "lthProfitSupply",
                  radius: "btc",
                  id: "B04-1-3",
                  introduce: "introduce.lthProfitSupply",
                  navigation: "lthProfitSupply",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance",
                },
                {
                  //长期持有者亏损总供应量 改为 长期持有者亏损供应量
                  path: "/",
                  label: "menu.lthLossSupply",
                  fullName: "menu.lthLossSupply2", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "lthLossSupply",
                  radius: "btc",
                  id: "B04-1-4",
                  introduce: "introduce.lthLossSupply",
                  navigation: "lthLossSupply",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance",
                },
                {
                  //长期持有者盈亏比
                  path: "/",
                  label: "menu.lthProfitRatio",
                  fullName: "menu.lthProfitRatio2", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "lthProfitRatio",
                  radius: "btc",
                  id: "B04-1-5",
                  introduce: "introduce.lthProfitRatio",
                  navigation: "lthProfitRatio",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance",
                },
                {
                  //短期持有者供应量
                  path: "/",
                  label: "menu.sthSupply",
                  fullName: "menu.sthSupply2", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "sthSupply",
                  radius: "btc",
                  id: "B04-1-13",
                  introduce: "introduce.sthSupply",
                  navigation: "sthSupply",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance",
                },
                {
                  //短期持有者盈利总供应量 改为短期持有者盈利供应量
                  path: "/",
                  label: "menu.sthProfitSupply",
                  fullName: "menu.sthProfitSupply2", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "sthProfitSupply",
                  radius: "btc",
                  id: "B04-1-6",
                  introduce: "introduce.sthProfitSupply",
                  navigation: "sthProfitSupply",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance",
                },
                {
                  //短期持有者亏损总供应量 改为短期持有者亏损供应量
                  path: "/",
                  label: "menu.sthLossSupply",
                  fullName: "menu.sthLossSupply2", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "sthLossSupply",
                  radius: "btc",
                  id: "B04-1-7",
                  introduce: "introduce.sthLossSupply",
                  navigation: "sthLossSupply",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance",
                },
                {
                  //短期持有者盈亏比
                  path: "/",
                  label: "menu.sthProfitRatio",
                  fullName: "menu.sthProfitRatio2", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "sthProfitRatio",
                  radius: "btc",
                  id: "B04-1-8",
                  introduce: "introduce.sthProfitRatio",
                  navigation: "sthProfitRatio",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance",
                },
                {
                  //长/短期持有者供应量盈亏比
                  path: "/",
                  label: "menu.relativeLthSth",
                  fullName: "menu.relativeLthSth2", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "relativeLthSth",
                  radius: "btc",
                  id: "B04-1-9",
                  introduce: "introduce.relativeLthSth",
                  navigation: "relativeLthSth",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance",
                },
                {
                  //短期到长期实现价值比率
                  path: "/",
                  label: "menu.SLRVRatio",
                  fullName: "menu.SLRVRatio2", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "SLRVRatio",
                  radius: "btc",
                  id: "B04-1-10",
                  introduce: "introduce.SLRVRatio",
                  navigation: "SLRVRatio",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance",
                },
                {
                  //长持者流通市值-已实现流通市值比 改为 长期持有者 MVRV Ratio
                  path: "/",
                  label: "menu.technology30",
                  fullName: "menu.lthmvrv", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "lthmvrv",
                  radius: "btc",
                  id: "B04-1-11",
                  introduce: "introduce.lthmvrv",
                  navigation: "lthmvrv", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance", //付费用户
                },
                {
                  //短持者流通市值-已实现流通市值比 改为 短期持有者 MVRV Ratio
                  path: "/",
                  label: "menu.technology31",
                  fullName: "menu.sthmvrv", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "sthmvrv",
                  radius: "btc",
                  id: "B04-1-12",
                  introduce: "introduce.sthmvrv",
                  navigation: "sthmvrv", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance", //付费用户
                },
                {
                  //长/短期持有者供应量盈亏分布
                  path: "/",
                  label: "menu.distributionLthSth",
                  fullName: "menu.distributionLthSth", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "distributionLthSth",
                  radius: "btc",
                  id: "B04-1-14",
                  introduce: "introduce.distributionLthSth",
                  navigation: "distributionLthSth", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance", //付费用户
                },
              ],
            },
            {
              //盈亏
              label: "menu.ProfitLoss",
              icon: "i izhexiantu-xianxing",
              id: "B05-1",
              children: [
                {
                  //流通市值
                  path: "/",
                  label: "menu.technology28",
                  fullName: "menu.marketcap", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "marketcap",
                  radius: "btc",
                  id: "B05-1-1",
                  introduce: "introduce.marketcap",
                  navigation: "marketcap", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest", //匿名用户
                },
                {
                  //  已实现流通市值  改为和流通市值合并显示在一个页面 后期修改拆分
                  path: "/",
                  label: "menu.technology29",
                  fullName: "menu.rcap", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "rcap",
                  radius: "btc",
                  id: "B05-1-17",
                  introduce: "introduce.rcap",
                  navigation: "rcap", //导航组件名称
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest",
                },
                {
                  //  已实现流通市值(找零消除)
                  path: "/",
                  label: "menu.earcap",
                  fullName: "menu.earcap2", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "earcap",
                  radius: "btc",
                  id: "B05-1-18",
                  introduce: "introduce.earcap1",
                  navigation: "earcap1", //导航组件名称
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
                {
                  //新的MVRV 改名 MVRV Ratio

                  path: "/",
                  label: "menu.technology1",
                  fullName: "menu.mvrv", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "market",
                  radius: "mvrv",
                  id: "B05-1-3",
                  introduce: "introduce.MVRV",
                  navigation: "mvrv",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest", //匿名用户
                },
                {
                  //MVRVZ  MVRV Z-Score
                  path: "/",
                  label: "menu.technology2",
                  fullName: "menu.technology2", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "market",
                  // req: "market",
                  radius: "MVRVZ",
                  coin: "BTC",
                  id: "B05-1-4",
                  introduce: "introduce.MVRVZ",
                  navigation: "MVRVZ", //导航组件名称
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest", //匿名用户
                },
                {
                  //流通速度
                  path: "/",
                  label: "menu.velocity",
                  fullName: "menu.velocity", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "velocity",
                  radius: "btc",
                  id: "B05-1-2",
                  introduce: "introduce.velocity",
                  navigation: "velocity",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },

                {
                  //已实现盈利量
                  path: "/",
                  label: "menu.technology25",
                  fullName: "menu.technology25", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "rprofit",
                  radius: "btc",
                  id: "B05-1-5",
                  formula: "", //介绍公式
                  introduce: "introduce.rprofit",
                  navigation: "rprofit", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                {
                  //已实现亏损量
                  path: "/",
                  label: "menu.technology26",
                  fullName: "menu.technology26", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "rloss",
                  radius: "btc",
                  id: "B05-1-6",
                  introduce: "introduce.rloss",
                  navigation: "rloss", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                {
                  //已实现净收益损失比
                  path: "/",
                  label: "menu.technology27",
                  fullName: "menu.technology27", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "rplRate",
                  radius: "btc",
                  id: "B05-1-7",
                  introduce: "introduce.rplRate",
                  navigation: "rplRate", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                {
                  //已实现价格
                  path: "/",
                  label: "menu.realizedPrice",
                  fullName: "menu.realizedPrice", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "realizedPrice",
                  radius: "btc",
                  id: "B05-1-8",
                  introduce: "introduce.realizedPrice",
                  navigation: "realizedPrice",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
                {
                  //已平衡价格
                  path: "/",
                  label: "menu.balancedPrice",
                  fullName: "menu.balancedPrice", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "balancedPrice",
                  radius: "btc",
                  id: "B05-1-9",
                  introduce: "introduce.balancedPrice",
                  navigation: "balancedPrice",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance",
                },
                {
                  //累积价值-销毁天数比
                  path: "/",
                  label: "menu.cvdd",
                  fullName: "menu.cvdd2", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "cvdd",
                  radius: "btc",
                  id: "B05-1-10",
                  introduce: "introduce.cvdd",
                  navigation: "cvdd",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
                {
                  //未实现的净收益量
                  path: "/",
                  label: "menu.technology33",
                  fullName: "menu.technology33", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "uprofit",
                  radius: "btc",
                  id: "B05-1-12",
                  introduce: "introduce.uprofit",
                  navigation: "uprofit", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                {
                  //未实现的净亏损量
                  path: "/",
                  label: "menu.technology34",
                  fullName: "menu.technology34", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "uloss",
                  radius: "btc",
                  id: "B05-1-13",
                  introduce: "introduce.uloss",
                  navigation: "uloss", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                {
                  //未实现的净收益损失比
                  path: "/",
                  label: "menu.technology32",
                  fullName: "menu.nupl", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "nupl",
                  radius: "btc",
                  id: "B05-1-11",
                  introduce: "introduce.nupl",
                  navigation: "nupl", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },

                {
                  //长持者未实现的净收益量 改为 长持者未实现的净收益损失比
                  path: "/",
                  label: "menu.technology35",
                  fullName: "menu.lthnupl", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "lthnupl",
                  radius: "btc",
                  id: "B05-1-14",
                  introduce: "introduce.lthnupl",
                  navigation: "lthnupl", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3", //改为1天
                  type: "L3",
                  authority: "advance", //付费用户
                },
                {
                  //短持者未实现的净收益量  改为 短持者未实现的净收益损失比
                  path: "/",
                  label: "menu.technology36",
                  fullName: "menu.sthnupl", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "sthnupl",
                  radius: "btc",
                  id: "B05-1-15",
                  introduce: "introduce.sthnupl",
                  navigation: "sthnupl", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3", //改为1天
                  type: "L3",
                  authority: "advance", //付费用户
                },
                {
                  //市值/交易价值比 NVT Ratio  改为 市盈率
                  path: "/",
                  label: "menu.nvtRatio",
                  fullName: "menu.nvtRatio2", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "nvtRatio",
                  radius: "btc",
                  id: "B05-1-16",
                  introduce: "introduce.nvtRatio",
                  navigation: "nvtRatio",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
                {
                  //NVT信号
                  path: "/",
                  label: "menu.nvtSign",
                  fullName: "menu.nvtSign", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "nvtSign",
                  radius: "btc",
                  id: "B05-1-19",
                  introduce: "introduce.nvtSign",
                  navigation: "nvtSign",
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
              ],
            },
            {
              //币龄
              label: "menu.Lifetime",
              icon: "i izhexiantu-xianxing",
              id: "B06-1",
              children: [
                {
                  //已花费输出平均寿命
                  path: "/",
                  label: "menu.technology18",
                  fullName: "menu.asol", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "asol",
                  radius: "btc",
                  id: "B06-1-1",
                  introduce: "introduce.asol",
                  navigation: "asol", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                {
                  //币天销毁量
                  path: "/",
                  label: "menu.technology37",
                  fullName: "menu.CDD", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "CDD",
                  radius: "btc",
                  id: "B06-1-2",
                  introduce: "introduce.CDD",
                  navigation: "CDD", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                {
                  //币天销毁量年龄分布
                  path: "/",
                  label: "menu.technology20",
                  fullName: "menu.soag", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "soag",
                  radius: "btc",
                  id: "B06-1-3",
                  introduce: "introduce.soag",
                  navigation: "soag", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                {
                  //已花费输出休眠平均天数
                  path: "/",
                  label: "menu.technology19",
                  fullName: "menu.technology19", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "dormancy",
                  radius: "btc",
                  id: "B06-1-4",
                  introduce: "introduce.dormancy",
                  navigation: "dormancy", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                {
                  //活跃度
                  path: "/",
                  label: "menu.technology24",
                  fullName: "menu.technology24", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "liveliness",
                  radius: "btc",
                  id: "B06-1-5",
                  introduce: "introduce.Liveliness",
                  navigation: "liveliness", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户"
                },
                {
                  //币天销毁量 拆分 币天销毁量(供应调整)
                  path: "/",
                  label: "menu.saCDD",
                  fullName: "menu.saCDD", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "saCDD",
                  radius: "btc",
                  id: "B06-1-6",
                  introduce: "introduce.CDD",
                  navigation: "saCDD", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                {
                  //已花费输出休眠平均天数 拆分 已花费输出休眠平均天数(供应量调整)
                  path: "/",
                  label: "menu.sadormancy",
                  fullName: "menu.sadormancy", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "sadormancy",
                  radius: "btc",
                  id: "B06-1-7",
                  introduce: "introduce.dormancy",
                  navigation: "sadormancy", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                // {
                //   //价值销毁天数（VDD）倍数 价值损毁天数倍数
                //   path: "/",
                //   label: "menu.vdd",
                //   fullName: "menu.vdd", //全名
                //   icon: "i igl-folderOpen",
                //   componentReq: "vdd",
                //   radius: "btc",
                //   id: "B06-1-8",
                //   introduce: "introduce.vdd",
                //   navigation: "VDD", //导航组件名称
                //   assets: "BTC",
                //   interval: "menu.interval3",
                //   type: "L2",
                //   authority: "registered", //注册用户
                // },
              ],
            },
            {
              //比率
              label: "menu.Ratio",
              icon: "i izhexiantu-xianxing",
              id: "B07-1",
              children: [
                {
                  //已实现盈利交易占比 改成 每日已实现盈利交易占比（redmine）
                  path: "/",
                  label: "menu.technology16",
                  fullName: "menu.technology16", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "profitrate",
                  radius: "btc",
                  id: "B07-1-1",
                  introduce: "introduce.profitrate",
                  navigation: "profitrate", //导航组件名称
                  assets: "BTC",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                {
                  //已花费输出盈利比
                  path: "/",
                  label: "menu.technology17",
                  fullName: "menu.SOPR", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "sopr",
                  radius: "btc",
                  id: "B07-1-2",
                  introduce: "introduce.sopr",
                  navigation: "sopr", //导航组件名称
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
              ],
            },
            {
              //持有者分布
              label: "menu.Holder",
              icon: "i izhexiantu-xianxing",
              id: "B08-1",
              children: [
                // {
                //   //按余额划分
                //   label: "menu.balanceGroup",
                //   icon: "i izhexiantu-xianxing",
                //   id: "B08-1-1",
                //   children: [
                //     {
                //       //持有者地址数分布( 按余额分段) 改为 地址数分布
                //       path: "/",
                //       label: "menu.onchain5",
                //       fullName: "menu.onchain5", //全名
                //       icon: "i igl-folderOpen",
                //       componentReq: "utxos",
                //       radius: "btc",
                //       id: "B08-1-1-1",
                //       introduce: "introduce.balanceDistribution",
                //       navigation: "utxos",
                //       assets: "BTC",
                //       interval: "menu.interval3",
                //       type: "L3",
                //       authority: "advance", //付费用户
                //     },
                //     {
                //       //持有者币数量分布(按余额分段) 改为 币数量分布
                //       path: "/",
                //       label: "menu.onchain6",
                //       fullName: "menu.onchain6", //全名
                //       icon: "i igl-folderOpen",
                //       componentReq: "utxos2nd",
                //       radius: "btc",
                //       id: "B08-1-1-2",
                //       introduce: "introduce.balanceDistribution",
                //       navigation: "utxos2nd",
                //       assets: "BTC",
                //       interval: "menu.interval3",
                //       type: "L3",
                //       authority: "advance", //付费用户
                //     },
                //   ],
                // },
                {
                  //按余额划分 改为 按余额划分地址数分布
                  label: "menu.balanceGroup2",
                  icon: "i izhexiantu-xianxing",
                  id: "B08-1-8",
                  children: [
                    {
                      //按余额划分 地址数分布 余额 <=0.01
                      path: "/",
                      label: "menu.addressBalance",
                      fullName: "menu.addressBalance", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "addressBalance",
                      radius: "btc",
                      id: "B08-1-8-1",
                      introduce: "introduce.balanceDistribution",
                      navigation: "addressBalance",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                    {
                      //按余额划分 地址数分布  余额 >=0.01 & <0.1
                      path: "/",
                      label: "menu.addressBalance1",
                      fullName: "menu.addressBalance1", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "addressBalance1",
                      radius: "btc",
                      id: "B08-1-8-2",
                      introduce: "introduce.balanceDistribution",
                      navigation: "addressBalance1",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                    {
                      //按余额划分 地址数分布  余额 >=0.1 & <1 
                      path: "/",
                      label: "menu.addressBalance2",
                      fullName: "menu.addressBalance2", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "addressBalance2",
                      radius: "btc",
                      id: "B08-1-8-3",
                      introduce: "introduce.balanceDistribution",
                      navigation: "addressBalance2",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                    {
                      //按余额划分 地址数分布  余额 >=1 & <10
                      path: "/",
                      label: "menu.addressBalance3",
                      fullName: "menu.addressBalance3", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "addressBalance3",
                      radius: "btc",
                      id: "B08-1-8-4",
                      introduce: "introduce.balanceDistribution",
                      navigation: "addressBalance3",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                    {
                      //按余额划分 地址数分布  余额 >=10 & <100
                      path: "/",
                      label: "menu.addressBalance4",
                      fullName: "menu.addressBalance4", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "addressBalance4",
                      radius: "btc",
                      id: "B08-1-8-5",
                      introduce: "introduce.balanceDistribution",
                      navigation: "addressBalance4",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                    {
                      //按余额划分 地址数分布  余额 >=100 & <1000
                      path: "/",
                      label: "menu.addressBalance5",
                      fullName: "menu.addressBalance5", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "addressBalance5",
                      radius: "btc",
                      id: "B08-1-8-6",
                      introduce: "introduce.balanceDistribution",
                      navigation: "addressBalance5",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                    {
                      //按余额划分 地址数分布  余额 >=1000 & <10000
                      path: "/",
                      label: "menu.addressBalance6",
                      fullName: "menu.addressBalance6", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "addressBalance6",
                      radius: "btc",
                      id: "B08-1-8-7",
                      introduce: "introduce.balanceDistribution",
                      navigation: "addressBalance6",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                    {
                      //按余额划分 地址数分布  余额 >=10000
                      path: "/",
                      label: "menu.addressBalance7",
                      fullName: "menu.addressBalance7", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "addressBalance7",
                      radius: "btc",
                      id: "B08-1-8-8",
                      introduce: "introduce.balanceDistribution",
                      navigation: "addressBalance7",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                   
                   
                   
                   
                  ],
                },
                {
                  //按余额划分 改为 按余额划分币数量分布
                  label: "menu.currencyGroup",
                  icon: "i izhexiantu-xianxing",
                  id: "B08-1-9",
                  children: [
                    {
                      //按余额划分 币数量分布 余额 <=0.01
                      path: "/",
                      label: "menu.currencyGroup1",
                      fullName: "menu.currencyGroup1", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "currencyGroup1",
                      radius: "btc",
                      id: "B08-1-9-1",
                      introduce: "introduce.balanceDistribution",
                      navigation: "currencyGroup1",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                    {
                      //按余额划分 币数量分布 余额 >=0.01 & <0.1
                      path: "/",
                      label: "menu.currencyGroup2",
                      fullName: "menu.currencyGroup2", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "currencyGroup2",
                      radius: "btc",
                      id: "B08-1-9-2",
                      introduce: "introduce.balanceDistribution",
                      navigation: "currencyGroup2",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                    {
                      //按余额划分 币数量分布 余额 >=0.1 & <1
                      path: "/",
                      label: "menu.currencyGroup3",
                      fullName: "menu.currencyGroup3", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "currencyGroup3",
                      radius: "btc",
                      id: "B08-1-9-3",
                      introduce: "introduce.balanceDistribution",
                      navigation: "currencyGroup3",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                    {
                      //按余额划分 币数量分布 "余额 >=1 & <10  
                      path: "/",
                      label: "menu.currencyGroup4",
                      fullName: "menu.currencyGroup4", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "currencyGroup4",
                      radius: "btc",
                      id: "B08-1-9-4",
                      introduce: "introduce.balanceDistribution",
                      navigation: "currencyGroup4",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                    {
                      //按余额划分 币数量分布 余额 >=10 & <100
                      path: "/",
                      label: "menu.currencyGroup5",
                      fullName: "menu.currencyGroup5", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "currencyGroup5",
                      radius: "btc",
                      id: "B08-1-9-5",
                      introduce: "introduce.balanceDistribution",
                      navigation: "currencyGroup5",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                    {
                      //按余额划分 币数量分布 余额 >=100 & <1000
                      path: "/",
                      label: "menu.currencyGroup6",
                      fullName: "menu.currencyGroup6", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "currencyGroup6",
                      radius: "btc",
                      id: "B08-1-9-6",
                      introduce: "introduce.balanceDistribution",
                      navigation: "currencyGroup6",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                    {
                      //按余额划分 币数量分布 余额 >=1000 & <10000
                      path: "/",
                      label: "menu.currencyGroup7",
                      fullName: "menu.currencyGroup7", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "currencyGroup7",
                      radius: "btc",
                      id: "B08-1-9-7",
                      introduce: "introduce.balanceDistribution",
                      navigation: "currencyGroup7",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                    {
                      //按余额划分 币数量分布 余额 >=10000
                      path: "/",
                      label: "menu.currencyGroup8",
                      fullName: "menu.currencyGroup8", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "currencyGroup8",
                      radius: "btc",
                      id: "B08-1-9-8",
                      introduce: "introduce.balanceDistribution",
                      navigation: "currencyGroup8",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                 
                 
                 
                   
                   
                   
                   
                  ],
                },
                {
                  //按持有时间划分
                  label: "menu.timeGroup",
                  icon: "i izhexiantu-xianxing",
                  id: "B08-1-2",
                  children: [
                    {
                      //持有者地址数分布( 按持有时间分段)  改为 地址数分布
                      path: "/",
                      label: "menu.onchain7",
                      fullName: "menu.onchain7", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "holder",
                      radius: "btc",
                      id: "B08-1-2-1",
                      introduce: "introduce.holder",
                      navigation: "holder",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                    {
                      //持有者币数量分布( 按持有时间分段) 改为 币数量分布
                      path: "/",
                      label: "menu.onchain8",
                      fullName: "menu.onchain8", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "holderBalance",
                      radius: "btc",
                      id: "B08-1-2-2",
                      introduce: "introduce.timeDivision",
                      navigation: "holderBalance",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                  ],
                },
                {
                  //按买入价格划分
                  label: "menu.priceGroup",
                  icon: "i izhexiantu-xianxing",
                  id: "B08-1-3",
                  children: [
                    {
                      //持有者地址数分布( 按买入价格分段) 改为 地址数分布
                      path: "/",
                      label: "menu.onchain9",
                      fullName: "menu.onchain9", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "getBuyData",
                      radius: "btc",
                      id: "B08-1-3-1",
                      introduce: "introduce.buyingPrice",
                      navigation: "buyData", //导航组件名称
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                    {
                      //持有者币数量分布( 按买入价格分段) 改为 币数量分布
                      path: "/", //与Buy Data共用
                      label: "menu.onchain10",
                      fullName: "menu.onchain10", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "getBuyAmountData",
                      radius: "btc",
                      id: "B08-1-3-2",
                      introduce: "introduce.buyingPrice",
                      navigation: "buyData", //导航组件名称
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                  ],
                },
                {
                  //按买卖价差划分
                  label: "menu.PriceDifference",
                  icon: "i izhexiantu-xianxing",
                  id: "B08-1-4",
                  children: [
                    {
                      //持有者地址数分布(盈亏) 改为  地址数分布
                      path: "/",
                      label: "menu.onchain11",
                      fullName: "menu.onchain11", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "getDiffData",
                      radius: "btc",
                      id: "B08-1-4-1",
                      introduce: "introduce.priceDivision",
                      navigation: "diffData", //导航组件名称
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                    {
                      //持有者币数量分布(盈亏) 改为 币数量分布
                      path: "/", //与Diff Data共用
                      label: "menu.onchain12",
                      fullName: "menu.onchain12", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "getDiffAmountData",
                      radius: "btc",
                      id: "B08-1-4-2",
                      introduce: "introduce.priceDivision1",
                      navigation: "diffData", //导航组件名称
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                  ],
                },
                {
                  //按按盈利划分
                  label: "menu.profitGroup",
                  icon: "i izhexiantu-xianxing",
                  id: "B08-1-5",
                  children: [
                    {
                      //持有者地址数分布(利润率)  改为 地址数分布
                      path: "/",
                      label: "menu.onchain13",
                      fullName: "menu.onchain13", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "getProfitData",
                      radius: "btc",
                      id: "B08-1-5-1",
                      introduce: "introduce.profitDistribution",
                      navigation: "profitData", //导航组件名称
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                    {
                      //持有者币数量分布(利润率) 改为 币数量分布
                      path: "/", //与Profit Data共用
                      label: "menu.onchain14",
                      fullName: "menu.onchain14", //全名
                      icon: "i igl-folderOpen",
                      componentReq: "getProfitAmountData",
                      radius: "btc",
                      id: "B08-1-5-2",
                      introduce: "introduce.profitDistribution",
                      navigation: "profitData", //导航组件名称
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                    },
                  ],
                },
                {
                  //地址详细分布
                  label: "menu.addressGroup",
                  icon: "i izhexiantu-xianxing",
                  id: "B08-1-6",
                  children: [
                    {
                      //余额>=0 and <0.01的地址 币龄分布表 改为 余额<0.01
                      // path: "/",
                      label: "menu.Currency2",
                      componentReq: "getDayBalanceData",
                      fullName: "menu.balanceData1", //全名
                      radius: "btc",
                      id: "B08-1-6-1",
                      value: 0,
                      introduce: "introduce.detailedDistribution",
                      navigation: "balanceData",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                      parameter: 0,
                    },
                    {
                      // path: "/",   改为 余额>=0.01 & < 0.1
                      label: "menu.Currency3",
                      componentReq: "getDayBalanceData",
                      fullName: "menu.balanceData2", //全名
                      radius: "btc",
                      id: "B08-1-6-2",
                      value: 0.01,
                      introduce: "introduce.detailedDistribution",
                      navigation: "balanceData",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                      parameter: 0.01,
                    },
                    {
                      // path: "/",  改为 余额>=0.1 & < 1
                      label: "menu.Currency4",
                      fullName: "menu.balanceData3", //全名
                      componentReq: "getDayBalanceData",
                      radius: "btc",
                      id: "B08-1-6-3",
                      value: 0.1,
                      introduce: "introduce.detailedDistribution",
                      navigation: "balanceData",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                      parameter: 0.1,
                    },
                    {
                      // path: "/",  余额>=1 & < 10
                      label: "menu.Currency5",
                      fullName: "menu.balanceData4", //全名
                      componentReq: "getDayBalanceData",
                      radius: "btc",
                      id: "B08-1-6-4",
                      value: 1,
                      introduce: "introduce.detailedDistribution",
                      navigation: "balanceData",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                      parameter: 1,
                    },
                    {
                      // path: "/", 余额>=10 & < 100
                      label: "menu.Currency6",
                      fullName: "menu.balanceData5", //全名
                      componentReq: "getDayBalanceData",
                      radius: "btc",
                      id: "B08-1-6-5",
                      value: 10,
                      introduce: "introduce.detailedDistribution",
                      navigation: "balanceData",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                      parameter: 10,
                    },
                    {
                      // path: "/",余额>=100 & < 1000
                      label: "menu.Currency7",
                      fullName: "menu.balanceData6", //全名
                      componentReq: "getDayBalanceData",
                      radius: "btc",
                      id: "B08-1-6-6",
                      value: 100,
                      introduce: "introduce.detailedDistribution",
                      navigation: "balanceData",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                      parameter: 100,
                    },
                    {
                      // path: "/", 余额>=1000 & < 10000
                      label: "menu.Currency8",
                      fullName: "menu.balanceData7", //全名
                      componentReq: "getDayBalanceData",
                      radius: "btc",
                      id: "B08-1-6-7",
                      value: 1000,
                      introduce: "introduce.detailedDistribution",
                      navigation: "balanceData",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                      parameter: 1000,
                    },
                    {
                      // path: "/", 余额>=10000
                      label: "menu.Currency9",
                      fullName: "menu.balanceData8", //全名
                      componentReq: "getDayBalanceData",
                      radius: "btc",
                      id: "B08-1-6-8",
                      value: 10000,
                      introduce: "introduce.detailedDistribution",
                      navigation: "balanceData",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                      parameter: 10000,
                    },
                  ],
                },
                {
                  //币数量详细分布
                  label: "menu.CoinQuantity",
                  icon: "i izhexiantu-xianxing",
                  id: "B08-1-7",
                  children: [
                    {
                      //余额>=0 and <0.01的币数量 币龄分布表 改为 余额<0.01
                      // path: "/",
                      label: "menu.Currency11",
                      fullName: "menu.balanceData9", //全名
                      componentReq: "getDayBalanceAmountData",
                      radius: "btc",
                      id: "B08-1-7-1",
                      value: 0,
                      introduce: "introduce.detailedDistribution",
                      navigation: "balanceData",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                      parameter: 0,
                    },
                    {
                      // path: "/", 余额>=0.01 & < 0.1
                      label: "menu.Currency12",
                      fullName: "menu.balanceData10", //全名
                      componentReq: "getDayBalanceAmountData",
                      radius: "btc",
                      id: "B08-1-7-2",
                      value: 0.01,
                      introduce: "introduce.detailedDistribution",
                      navigation: "balanceData",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                      parameter: 0.01,
                    },
                    {
                      // path: "/",余额>=0.1 & < 1
                      label: "menu.Currency13",
                      fullName: "menu.balanceData11", //全名
                      componentReq: "getDayBalanceAmountData",
                      radius: "btc",
                      id: "B08-1-7-3",
                      value: 0.1,
                      introduce: "introduce.detailedDistribution",
                      navigation: "balanceData",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                      parameter: 0.1,
                    },
                    {
                      // path: "/",  余额>=1 & < 10
                      label: "menu.Currency14",
                      fullName: "menu.balanceData12", //全名
                      componentReq: "getDayBalanceAmountData",
                      radius: "btc",
                      id: "B08-1-7-4",
                      value: 1,
                      introduce: "introduce.detailedDistribution",
                      navigation: "balanceData",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                      parameter: 1,
                    },
                    {
                      // path: "/", 余额>=10 & < 100
                      label: "menu.Currency15",
                      fullName: "menu.balanceData13", //全名
                      componentReq: "getDayBalanceAmountData",
                      radius: "btc",
                      id: "B08-1-7-5",
                      value: 10,
                      introduce: "introduce.detailedDistribution",
                      navigation: "balanceData",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                      parameter: 10,
                    },
                    {
                      // path: "/",  余额>=100 & < 1000
                      label: "menu.Currency16",
                      fullName: "menu.balanceData14", //全名
                      componentReq: "getDayBalanceAmountData",
                      radius: "btc",
                      id: "B08-1-7-6",
                      value: 100,
                      introduce: "introduce.detailedDistribution",
                      navigation: "balanceData",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                      parameter: 100,
                    },
                    {
                      // path: "/", 余额>=1000 & < 10000
                      label: "menu.Currency17",
                      fullName: "menu.balanceData15", //全名
                      componentReq: "getDayBalanceAmountData",
                      radius: "btc",
                      id: "B08-1-7-7",
                      value: 1000,
                      introduce: "introduce.detailedDistribution",
                      navigation: "balanceData",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                      parameter: 1000,
                    },
                    {
                      // path: "/",  余额>=10000
                      label: "menu.Currency18",
                      fullName: "menu.balanceData16", //全名
                      componentReq: "getDayBalanceAmountData",
                      radius: "btc",
                      id: "B08-1-7-8",
                      value: 10000,
                      introduce: "introduce.detailedDistribution",
                      navigation: "balanceData",
                      assets: "BTC",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance", //付费用户
                      parameter: 10000,
                    },
                  ],
                },
              ],
            },
          ],
        },
        //#region
        // {
        //   //链上数据
        //   label: "menu.onchain",
        //   icon: "i itubiao2",
        //   nested: "peers", //没有多层嵌套
        //   id: "01",
        //   children: [

        //     // {
        //     //   //日交易统计
        //     //   path: "/",
        //     //   label: "menu.onchain19",
        //     //   icon: "i igl-folderOpen",
        //     //   componentReq: "BTCVolume",
        //     //   radius: "btc",
        //     //   id: "01-4",
        //     //   introduce: "introduce.BTCVolume",
        //     //   navigation: "volume", //导航组件名称
        //     //   assets: "BTC、ETH",
        //     //   interval: "menu.interval3",
        //     // },

        //     // { //暂时不渲染  累计币天销毁量(流通供应量）
        //     //   path: "/",
        //     //   label: "menu.technology22",
        //     //   icon: "i igl-folderOpen",
        //     //   componentReq: "sumcsupply",
        //     //   radius: "btc",
        //     //   id: "01-11",
        //     //   introduce:
        //     //     "Liveliness to vary between a value of 1 for a protocol where every coin is spent at once, and 0 for a protocol where no transaction has taken place. Analysis of metric values between the theoretical extremes of 1 and 0 can generally be considered within the following framework:Liveliness will decrease when a high proportion of coin supply is dormant (i.e. HODLing behaviour) and the global coin day accumulation outpaces coin days destroyed in on-chain activity. Liveliness will trend sideways where coin days destroyed are equal to the coin days accumulated by the circulating supply.Liveliness will increase when long term holders begin spending old coins that have accumulated large volumes of coin days that exceed the rate of global coin day accumulation.",
        //     //   navigation: "sumcsupply", //导航组件名称
        //     //   assets: "BTC",
        //     //   interval: "menu.interval3",
        //     // },
        //     // {//暂时不渲染 累计币天销毁量
        //     //   path: "/",
        //     //   label: "menu.technology23",
        //     //   icon: "i igl-folderOpen",
        //     //   componentReq: "sumcdd",
        //     //   radius: "btc",
        //     //   id: "01-12",
        //     //   introduce:
        //     //     "Liveliness to vary between a value of 1 for a protocol where every coin is spent at once, and 0 for a protocol where no transaction has taken place. Analysis of metric values between the theoretical extremes of 1 and 0 can generally be considered within the following framework:Liveliness will decrease when a high proportion of coin supply is dormant (i.e. HODLing behaviour) and the global coin day accumulation outpaces coin days destroyed in on-chain activity. Liveliness will trend sideways where coin days destroyed are equal to the coin days accumulated by the circulating supply.Liveliness will increase when long term holders begin spending old coins that have accumulated large volumes of coin days that exceed the rate of global coin day accumulation.",
        //     //   navigation: "sumcdd", //导航组件名称
        //     //   assets: "BTC",
        //     //   interval: "menu.interval3",
        //     // },

        //     // {
        //     //   //矿工地址余额
        //     //   path: "/",
        //     //   label: "menu.onchain21",
        //     //   icon: "i igl-folderOpen",
        //     //   componentReq: "minerBalance",
        //     //   radius: "btc",
        //     //   id: "01-24",
        //     //   introduce: "introduce.minerBalance",
        //     //   navigation: "minerBalance", //导航组件名称
        //     //   assets: "BTC",
        //     //   interval: "menu.interval3",
        //     // },
        //   ],
        // },
        //#endregion
        {
          //市场技术指标 改为 市场指标
          label: "menu.market",
          icon: "i i-zhuzhuangtu",
          nested: "peers", //判断是否多层嵌套
          id: "2",
          children: [
            {
              //江卓尔60日累计涨幅
              path: "/",
              label: "menu.technology6",
              fullName: "menu.jzr60", //全名
              icon: "i igl-folderOpen",
              componentReq: "jzr60",
              radius: "btc",
              id: "2-1",
              // conditions: "arh", //不同请求方式筛选条件
              introduce: "introduce.jzr60",
              navigation: "jzr60",
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //arh999囤币及逃顶指标
              path: "/",
              label: "menu.technology7",
              fullName: "menu.arh999", //全名
              icon: "i igl-folderOpen",
              componentReq: "arh99",
              radius: "btc",
              id: "2-2",
              navigation: "arh999",
              // conditions: "arh", //不同请求方式筛选条件
              introduce: "introduce.arh999",
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //匿名用户
            },
            // {
            //   //天针
            //   path: "/",
            //   label: "menu.technology8",
            //   icon: "i igl-folderOpen",
            //   componentReq: "天针",
            //   radius: "btc",
            //   id: "2-3",
            //   introduce: "introduce.DaysNeedle",
            //   navigation: "DaysNeedle", //导航组件名称
            //   assets: "无",
            //   interval: "menu.interval3",
            // },
            {
              //2年移动平均价格乘数
              path: "/",
              label: "menu.technology11",
              fullName: "menu.ma730", //全名
              icon: "i igl-folderOpen",
              componentReq: "ma730",
              radius: "btc",
              id: "2-4",
              introduce: "introduce.ma730",
              navigation: "ma730", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //币价当前市值排名
              path: "/",
              label: "menu.onchain17",
              fullName: "menu.coinmarketall", //全名
              icon: "i igl-folderOpen",
              componentReq: "币价当前市值排名",
              radius: "btc",
              id: "2-5",
              introduce: "introduce.coinmarketall",
              navigation: "coinmarketall", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },

            // {
            //   //日K线 删除不显示
            //   path: "/",
            //   label: "menu.technology5",
            //   icon: "i igl-folderOpen",
            //   componentReq: "OHLCPrice",
            //   radius: "BTC",
            //   id: "2-7",
            //   introduce: "introduce.OHLCPrice",
            //   navigation: "ETH",
            //   assets: "BTC, ETH",
            //   interval: "menu.interval3",
            //   type: "L2",
            //   authority: "registered", //注册用户
            // },
            //  {
            //   //登录遮罩
            //   path: "/",
            //   label: "遮罩",
            //   icon: "i igl-folderOpen",
            //   componentReq: "mask",
            //   radius: "BTC",
            //   id: "2-8",
            //   introduce: "",
            //   navigation: "loginMask",
            //   assets: "BTC, ETH",
            //   interval: "menu.interval3",
            // },
            {
              //PI周期顶指标
              path: "/",
              label: "menu.PiCycleTopIndicator",
              fullName: "menu.PiCycleTopIndicator", //全名
              icon: "i igl-folderOpen",
              componentReq: "piCycleTop",
              radius: "btc",
              id: "2-9",
              introduce: "introduce.PiCycleTopIndicator",
              navigation: "piCycleTop", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //稳定币供应比
              path: "/",
              label: "menu.ssr",
              fullName: "menu.ssr", //全名
              icon: "i igl-folderOpen",
              componentReq: "ssr",
              radius: "btc",
              id: "2-10",
              introduce: "introduce.ssr",
              navigation: "ssr", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered",
            },
            {
              //稳定币供应比振荡器
              path: "/",
              label: "menu.ssro",
              fullName: "menu.ssro", //全名
              icon: "i igl-folderOpen",
              componentReq: "ssro",
              radius: "btc",
              id: "2-11",
              introduce: "introduce.ssro",
              navigation: "ssro", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered",
            },
            {
              //库存/新发行比
              path: "/",
              label: "menu.stfRatio",
              fullName: "menu.stfRatio", //全名
              icon: "i igl-folderOpen",
              componentReq: "stfRatio",
              radius: "btc",
              id: "2-12",
              introduce: "introduce.stfRatio",
              navigation: "stfRatio", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest",
            },
            {
              //库存/新发行偏差
              path: "/",
              label: "menu.stfDeflection",
              fullName: "menu.stfDeflection", //全名
              icon: "i igl-folderOpen",
              componentReq: "stfDeflection",
              radius: "btc",
              id: "2-13",
              introduce: "introduce.stfDeflection",
              navigation: "stfDeflection", //导航组件名称
              assets: "BTC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered",
            },
            {
              //黄金比例乘数
              path: "/",
              label: "menu.goldenRatioMult",
              fullName: "menu.goldenRatioMult", //全名
              icon: "i igl-folderOpen",
              componentReq: "goldenRatioMult",
              radius: "btc",
              id: "2-14",
              introduce: "introduce.goldenRatioMult",
              navigation: "goldenRatioMult", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered",
            },
          ],
        },
        // {
        //   //宏观指标 改为 宏观经济指标
        //   label: "menu.macro",
        //   icon: "i itubiao1",
        //   nested: "peers", //判断是否多层嵌套
        //   id: "3",
        //   children: [
        //     {
        //       //纳斯达克指数
        //       path: "/",
        //       label: "menu.macro1",
        //       fullName: "menu.macro1", //全名
        //       icon: "i igl-folderOpen",
        //       componentReq: "NDAQohlc",
        //       id: "3-1",
        //       introduce: "introduce.NDAQohlc",
        //       navigation: "ndaqOhlc",
        //       assets: "无",
        //       interval: "menu.interval3",
        //       type: "L1",
        //       authority: "guest", //匿名用户
        //     },
        //     {
        //       //纳斯达克/BTC日K线 改为 纳斯达克指数 vs BTC
        //       path: "/",
        //       label: "menu.macro2",
        //       fullName: "menu.macro2", //全名
        //       icon: "i igl-folderOpen",
        //       componentReq: "NDAQBTCPrice",
        //       id: "3-2",
        //       introduce: "introduce.NDAQBTCPrice",
        //       navigation: "NdaqBtcDayKline",
        //       assets: "无",
        //       interval: "menu.interval3",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //     {
        //       //市场快讯 金十数据
        //       path: "/",
        //       label: "menu.quickNews",
        //       fullName: "menu.quickNews", //全名
        //       icon: "i igl-folderOpen",
        //       componentReq: "NDAQBTCPrice",
        //       id: "3-3",
        //       introduce: "introduce.quickNews",
        //       navigation: "quickNews",
        //       assets: "无",
        //       interval: "home.no",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //     {
        //       //财经日历 金十数据
        //       path: "/",
        //       label: "menu.economics",
        //       fullName: "menu.economics", //全名
        //       icon: "i igl-folderOpen",
        //       componentReq: "NDAQBTCPrice",
        //       id: "3-4",
        //       introduce: "introduce.quickNews",
        //       navigation: "economics",
        //       assets: "无",
        //       interval: "home.no",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //     {
        //       //国债收益率
        //       path: "/",
        //       label: "menu.USTreasuriesYields",
        //       fullName: "menu.USTreasuriesYields", //全名
        //       icon: "i igl-folderOpen",
        //       componentReq: "USTreasuriesYields",
        //       id: "3-5",
        //       introduce: "introduce.USTreasuriesYields",
        //       navigation: "USTreasuriesYields",
        //       assets: "无",
        //       interval: "home.no",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //     {
        //       //货币供应量
        //       path: "/",
        //       label: "menu.MoneyStockMeasures",
        //       fullName: "menu.MoneyStockMeasures", //全名
        //       icon: "i igl-folderOpen",
        //       componentReq: "MoneyStockMeasures",
        //       id: "3-6",
        //       introduce: "introduce.MoneyStockMeasures",
        //       navigation: "MoneyStockMeasures",
        //       assets: "无",
        //       interval: "home.no",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //     {
        //       //私营部门贷款
        //       path: "/",
        //       label: "menu.loanPsi",
        //       fullName: "menu.loanPsi", //全名
        //       icon: "i igl-folderOpen",
        //       componentReq: "loanPsi",
        //       id: "3-7",
        //       introduce: "introduce.loanPsi",
        //       navigation: "loanPsi",
        //       assets: "无",
        //       interval: "home.no",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //     {
        //       //私人债务占GDP比重
        //       path: "/",
        //       label: "menu.loanGdp",
        //       fullName: "menu.loanGdp", //全名
        //       icon: "i igl-folderOpen",
        //       componentReq: "loanGdp",
        //       id: "3-8",
        //       introduce: "introduce.loanGdp",
        //       navigation: "loanGdp",
        //       assets: "无",
        //       interval: "home.no",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //     {
        //       //每周经济指数
        //       path: "/",
        //       label: "menu.wei",
        //       fullName: "menu.wei", //全名
        //       icon: "i igl-folderOpen",
        //       componentReq: "wei",
        //       id: "3-9",
        //       introduce: "introduce.wei",
        //       navigation: "wei",
        //       assets: "无",
        //       interval: "home.no",
        //       type: "L2",
        //       authority: "registered", //注册用户
        //     },
        //   ],
        // },
        {
          //交易所数据

          label: "menu.exchange",
          icon: "i itubiao2",
          nested: "peers", //判断是否多层嵌套
          id: "4",
          children: [
            //#region
            // {
            //   //合约K线
            //   path: "/Bian",
            //   label: "menu.exchange1",
            //   icon: "i igl-folderOpen",
            //   // componentReq: "list",
            //   radius: "bian",
            //   id: "4-1",
            //   navigation: "bianController",
            //   introduce: "introduce.bian",
            //   assets:
            //     "'BTCUSDT,ETHUSDT,BCHUSDT,XRPUSDT,EOSUSDT,LTCUSDT,TRXUSDT,ETCUSDT,LINKUSDT,XLMUSDT,ADAUSDT,XMRUSDT,DASHUSDT,ZECUSDT,XTZUSDT,BNBUSDT,ATOMUSDT,ONTUSDT,IOTAUSDT,BATUSDT,VETUSDT,NEOUSDT,QTUMUSDT,IOSTUSDT,THETAUSDT,ALGOUSDT,ZILUSDT,KNCUSDT,ZRXUSDT,COMPUSDT,OMGUSDT,DOGEUSDT,SXPUSDT,KAVAUSDT,BANDUSDT,RLCUSDT,WAVESUSDT,MKRUSDT,SNXUSDT,DOTUSDT,DEFIUSDT,YFIUSDT,BALUSDT,CRVUSDT,TRBUSDT,RUNEUSDT,SUSHIUSDT,SRMUSDT,EGLDUSDT,SOLUSDT,ICXUSDT,STORJUSDT,BLZUSDT,UNIUSDT,AVAXUSDT,FTMUSDT,HNTUSDT,ENJUSDT,FLMUSDT,TOMOUSDT,RENUSDT,KSMUSDT,NEARUSDT,AAVEUSDT,FILUSDT,RSRUSDT,LRCUSDT,MATICUSDT,OCEANUSDT,CVCUSDT,BELUSDT,CTKUSDT,AXSUSDT,ALPHAUSDT,ZENUSDT,SKLUSDT,GRTUSDT,1INCHUSDT,CHZUSDT,SANDUSDT,ANKRUSDT,BTSUSDT,LITUSDT,UNFIUSDT,REEFUSDT,RVNUSDT,SFPUSDT,XEMUSDT,BTCSTUSDT,COTIUSDT,CHRUSDT,MANAUSDT,ALICEUSDT,HBARUSDT'",
            //   interval: "menu.interval3",
            // },
            // {
            //   //交易量
            //   path: "/", //与Get Top List共用
            //   label: "menu.exchange2",
            //   icon: "i igl-folderOpen",
            //   componentReq: "priceValue",
            //   radius: "btc",
            //   id: "4-2",
            //   introduce: "introduce.priceValue",
            //   navigation: "priceValue", //导航组件名称
            //   assets: "BTC",
            //   interval: "menu.interval3",
            // },
            //#endregion
            {
              //资金费率
              path: "/",
              label: "menu.technology13",
              fullName: "menu.technology13", //全名
              icon: "i igl-folderOpen",
              componentReq: "fundingRate",
              radius: "btc",
              id: "4-3",
              introduce: "introduce.fundingRate",
              navigation: "fundingRate", //导航组件名称
              assets: "BTCUSDT、ETHUSDT",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //注册用户
            },
            {
              //未平仓合约数
              path: "/",
              label: "menu.technology14",
              fullName: "menu.technology14", //全名
              icon: "i igl-folderOpen",
              componentReq: "openInterest",
              radius: "btc",
              id: "4-4",
              introduce: "introduce.openInterest",
              navigation: "openInterest", //导航组件名称
              assets: "BTCUSDT、ETHUSDT",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },

            {
              //合约主动买入量
              path: "/",
              label: "menu.technology15",
              fullName: "menu.technology15", //全名
              icon: "i igl-folderOpen",
              componentReq: "takerlongshortRatio",
              radius: "btc",
              id: "4-5",
              introduce: "introduce.takerlongshortRatio",
              navigation: "takerlongshortRatio", //导航组件名称
              assets: "BTCUSDT、ETHUSDT",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //时区购买力
              path: "/",
              label: "menu.tzbp",
              fullName: "menu.tzbp", //全名
              icon: "i igl-folderOpen",
              componentReq: "tzbp",
              radius: "btc",
              id: "4-6",
              introduce: "introduce.tzbp",
              navigation: "tzbp", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            {
              //买入大单挂单
              path: "/",
              label: "menu.bobp",
              fullName: "menu.bobp", //全名
              icon: "i igl-folderOpen",
              componentReq: "bobp",
              radius: "btc",
              id: "4-7",
              introduce: "introduce.bobp",
              navigation: "bobp", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            {
              //卖出大单挂单
              path: "/",
              label: "menu.bosp",
              fullName: "menu.bosp", //全名
              icon: "i igl-folderOpen",
              componentReq: "bosp",
              radius: "btc",
              id: "4-8",
              introduce: "introduce.bobp", //买入卖出都一样
              navigation: "bosp", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            // {
            //   //成交量分布图
            //   path: "/",
            //   label: "menu.volumeProfile",
            //   fullName: "menu.volumeProfile", //全名
            //   icon: "i igl-folderOpen",
            //   componentReq: "volumeProfile",
            //   radius: "btc",
            //   id: "4-9",
            //   introduce: "introduce.volumeProfile",
            //   navigation: "volumeProfile", //导航组件名称
            //   assets: "BTC",
            //   interval: "menu.interval3",
            //   type: "L3",
            //   authority: "advance",
            // },
            // {
            //   //交易所余额
            //   path: "/",
            //   label: "menu.exchange10",
            //   fullName: "menu.exchange10", //全名
            //   icon: "i igl-folderOpen",
            //   componentReq: "exchange",
            //   radius: "btc",
            //   id: "4-10",
            //   introduce: "introduce.exchange1",
            //   navigation: "exchange", //导航组件名称
            //   assets: "BTC、ETH",
            //   interval: "menu.interval3",
            //   type: "L2",
            //   authority: "registered",
            // },
            {
              //合约主动买入量 拆分出来 合约主动买入量(买卖比率)
              path: "/",
              label: "menu.sellRatio",
              fullName: "menu.sellRatio", //全名
              icon: "i igl-folderOpen",
              componentReq: "sellRatio",
              radius: "btc",
              id: "4-11",
              introduce: "introduce.takerlongshortRatio",
              navigation: "sellRatio", //导航组件名称
              assets: "BTCUSDT、ETHUSDT",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
          ],
        },
        //#region
        // {
        //   //持有者分布
        //   label: "menu.holders",
        //   icon: "i izhexiantu-xianxing",
        //   nested: "peers", //判断是否多层嵌套
        //   id: "5",
        //   children: [

        //     //   {
        //     //   //持有者地址数分布 这个就是多层的
        //     //   label: "menu.holderAddress",
        //     //   icon: "i izhexiantu-xianxing",
        //     //   id: "B08-1-6",
        //     //   children: [
        //     //     {
        //     //       //余额>=0 and <0.01的地址 币龄分布表
        //     //       // path: "/",
        //     //       label: "menu.Currency2",
        //     //       componentReq: "getDayBalanceData",
        //     //       radius: "btc",
        //     //       id: "01-35-1",
        //     //       value: 0,
        //     //       introduce: "introduce.getDayBalanceData",
        //     //       navigation: "balanceData",
        //     //       assets: "BTC",
        //     //       interval: "menu.interval3",
        //     //       type: "L3",
        //     //       authority: "advance", //付费用户
        //     //     },

        //     //   ],
        //     // },
        //     {
        //       //持有者地址数详细分布(按持有时间分段)  这个就是多层的
        //       label: "menu.Currency1",
        //       icon: "i izhexiantu-xianxing",
        //       id: "01-35",
        //       children: [

        //       ],
        //     },
        //     {
        //       //持有者币数量详细分布(按持有时间分段)

        //       label: "menu.Currency10",
        //       icon: "i izhexiantu-xianxing",
        //       id: "01-36",
        //       children: [

        //       ],
        //     },
        //   ],
        // },

        // {
        //   label: "待分配",
        //   icon: "i itubiao2",
        //   nested: "peers", //判断是否多层嵌套
        //   id: "100",
        //   children: [
        //     // {
        //     //   //新的MVRV
        //     //   path: "/",
        //     //   label: "新的MVRV",
        //     //   icon: "i igl-folderOpen",
        //     //   componentReq: "ethbigtxcount",
        //     //   radius: "btc",
        //     //   id: "23-100",
        //     //   introduce: "introduce.ethbigtxcount",
        //     //   navigation: "mvrv",
        //     //   assets: "BTC、ETH",
        //     //   interval: "menu.interval3",
        //     // },

        //     // {//区块实时交易量 不显示
        //     //   path: "/",
        //     //   label: "menu.onchain3",
        //     //   icon: "i igl-folderOpen",
        //     //   componentReq: "blockAmount",
        //     //   radius: "btc",
        //     //   id: "23-13",
        //     //   introduce: "introduce.blockAmount",
        //     //   navigation: "blockAmount",
        //     //   assets: "BTC",
        //     //   interval: "menu.interval3",
        //     // },
        //     // {
        //     //   //日交易详情
        //     //   path: "/",
        //     //   label: "menu.onchain4",
        //     //   icon: "i igl-folderOpen",
        //     //   componentReq: "dailyBuySell",
        //     //   radius: "btc",
        //     //   id: "23-14",
        //     //   introduce: "introduce.dailyBuySell",
        //     //   navigation: "dailyBuySell",
        //     //   assets: "BTC",
        //     //   interval: "menu.interval3",
        //     // },

        //     // {//暂时注释 巨鲸 币数量变动 /改为 巨鲸交易监控
        //     //   path: "/", //与Get Top List共用
        //     //   label: "menu.onchain16",
        //     //   icon: "i igl-folderOpen",
        //     //   componentReq: "getTopListWatch",
        //     //   radius: "btc",
        //     //   id: "23-26",
        //     //   introduce: "introduce.getTopListWatch",
        //     //   navigation: "topList", //导航组件名称
        //     //   assets: "BTC",
        //     //   interval: "menu.interval3",
        //     // },

        //     // {//地址对应标记持有者名称关系列表
        //     //   path: "/",
        //     //   label: "menu.onchain18",
        //     //   icon: "i igl-folderOpen",
        //     //   componentReq: "btcTags",
        //     //   radius: "btc",
        //     //   id: "23-32",
        //     //   introduce: "introduce.btcTags",
        //     //   navigation: "btctags", //导航组件名称
        //     //   assets: "BTC、ETH",
        //     //   interval: "menu.interval3",
        //     // },
        //   ],
        // },
        // {
        //   //技术指标
        //   label: "menu.technology",
        //   icon: "i izhexiantu-xianxing",
        //   nested: "peers", //判断是否多层嵌套 就是这些 多给他一个键 就是对应多语言的键 每个项都要有对把 对 先写两个试试
        //   id: "1",
        //   children: [
        //     // {
        //     //   //MVRV
        //     //   path: "/",
        //     //   label: "menu.technology1",
        //     //   icon: "i igl-folderOpen",
        //     //   req: "market",
        //     //   radius: `mvrv`,
        //     //   coin: "BTC",
        //     //   id: "23-1",
        //     //   introduce: "introduce.MVRV",
        //     //   assets: "BTC、ETH、LTC",
        //     //   interval: "menu.interval3",
        //     //   currencyNavigation: "USDT",
        //     // },

        //     // {//NVTRatio
        //     //   path: "/",
        //     //   label: "menu.technology3",
        //     //   icon: "i igl-folderOpen",
        //     //   req: "market",
        //     //   radius: "NVTRatio",
        //     //   coin: "BTC",
        //     //   id: "1-3",
        //     //   introduce: "introduce.NVTRatio",
        //     //   assets: "BTC、ETH、LTC",
        //     //   interval: "menu.interval3",
        //     // },
        //     // {//NVTSignal
        //     //   path: "/",
        //     //   label: "menu.technology4",
        //     //   icon: "i igl-folderOpen",
        //     //   req: "market",
        //     //   radius: "NVTSignal",
        //     //   coin: "BTC",
        //     //   id: "1-4",
        //     //   introduce: "introduce.NVTSignal",
        //     //   assets: "BTC、ETH、LTC",
        //     //   interval: "menu.interval3",
        //     // },

        //     // {
        //     //   //ETF持有比特币
        //     //   path: "/",
        //     //   label: "menu.technology9",
        //     //   icon: "i igl-folderOpen",
        //     //   req: "ETF",
        //     //   radius: "Holding",
        //     //   id: "1-9",
        //     //   introduce: "introduce.Holding",
        //     //   assets: "无",
        //     //   interval: "menu.interval3",
        //     // },
        //     // {
        //     //   //ETF比特币变动
        //     //   path: "/",
        //     //   label: "menu.technology10",
        //     //   icon: "i igl-folderOpen",
        //     //   req: "ETF",
        //     //   radius: "Flows",
        //     //   id: "1-10",
        //     //   introduce: "introduce.Flows",
        //     //   assets: "无",
        //     //   interval: "menu.interval3",
        //     // },

        //     // {
        //     //   //已实现流通市值
        //     //   path: "/",
        //     //   label: "menu.technology12",
        //     //   icon: "i igl-folderOpen",
        //     //   componentReq: "capReal",
        //     //   radius: "btc",
        //     //   id: "1-12",
        //     //   introduce: "introduce.capReal",
        //     //   navigation: "capReal", //导航组件名称
        //     //   assets: "BTC",
        //     //   interval: "menu.interval3",
        //     // },

        //   ],
        // },

        // {//地址/活动地址/新增地址及下面的页面
        //   label: "menu.address",
        //   icon: "i iqianbao",
        //   id: "4",
        //   children: [
        //     {
        //       path: "/",
        //       label: "menu.address1",
        //       icon: "i 24igl-folderOpen",
        //       type: "L1",
        //       id: "4-1",
        //       children: [
        //         {
        //           // path: "/1",
        //           label: `menu.address2`,
        //           req: "activeAddress",
        //           radius: "btc",
        //           id: "4-1-1",
        //           introduce: "introduce.activeAddress",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           // path: "/2",
        //           label: "menu.address3",
        //           req: "sendingAddress",
        //           radius: "btc",
        //           id: "4-1-2",
        //           introduce: "introduce.sendingAddress",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           // path: "/3",
        //           label: "menu.address4",
        //           req: "receivingAddress",
        //           radius: "btc",
        //           id: "4-1-3",
        //           introduce: "introduce.receivingAddress",
        //           interval: "menu.interval3",
        //         },
        //       ],
        //     },
        //     {
        //       path: "/",
        //       label: "menu.address5",
        //       icon: "i 24igl-folderOpen",
        //       type: "L1",
        //       id: "4-2",
        //       children: [
        //         {
        //           path: "/1",
        //           label: "menu.address6",
        //           req: "newAddress",
        //           radius: "btc",
        //           id: "4-2-1",
        //           introduce: "introduce.newAddress",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           path: "/2",
        //           label: "menu.address7",
        //           req: "totalAddress",
        //           radius: "btc",
        //           id: "4-2-2",
        //           introduce: "introduce.totalAddress",
        //           interval: "menu.interval3",
        //         },
        //       ],
        //     },
        //   ],
        // },

        // {
        //   ///交易汇总
        //   label: "menu.transactions",
        //   icon: "i ijiantou_zuoyouqiehuan",
        //   id: "20",
        //   children: [
        //     {
        //       //交易规模
        //       // path: "/",
        //       label: "menu.transactions1",
        //       icon: "i iyonghuguanli_huaban",
        //       type: "L1",
        //       id: "20-1",
        //       children: [
        //         {
        //           //每天交易规模
        //           // path: "/",
        //           label: "menu.transactions2",
        //           req: "transsizetotal",
        //           radius: "btc",
        //           id: "20-1-1",
        //           introduce: "introduce.transsizetotal",
        //           assets: "BTC",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           //每秒交易规模
        //           // path: "/",
        //           label: "menu.transactions3",
        //           req: "transsizemean",
        //           radius: "btc",
        //           id: "20-1-2",
        //           introduce: "introduce.transsizemean",
        //           assets: "BTC",
        //           interval: "menu.interval3",
        //         },
        //       ],
        //     },
        //     {
        //       //交易量
        //       // path: "/",
        //       label: "menu.transactions4",
        //       icon: "i iyonghuguanli_huaban",
        //       type: "L1",
        //       id: "20-2",
        //       children: [
        //         {
        //           //成交次数
        //           // path: "/",
        //           label: "menu.transactions5",
        //           req: "transactions",
        //           radius: "btc",
        //           id: "20-2-1",
        //           introduce: "introduce.transactions",
        //           assets: "BTC、ETH、LTC",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           //日成交率
        //           // path: "/",
        //           label: "menu.transactions6",
        //           req: "transrate",
        //           radius: "btc",
        //           id: "20-2-2",
        //           introduce: "introduce.transrate",
        //           assets: "BTC、ETH、LTC",
        //           interval: "menu.interval3",
        //         },
        //       ],
        //     },
        //   ],
        // },

        // {//分配数据
        //   label: "menu.Distribution",
        //   icon: "i izhexiantu_o",
        //   nested: "peers", //判断是否多层嵌套
        //   id: "33",
        //   children: [
        //     {
        //       path: "/",
        //       label: "menu.Distribution1",
        //       icon: "i iwenjianjia",
        //       type: "L2",
        //       req: "distribution",
        //       radius: "tenths",
        //       coin: "BTC",
        //       id: "33-1",
        //       assets: "BTC、ETH",
        //       introduce: "introduce.distribution",
        //       interval: "menu.interval3",
        //     },
        //     {
        //       path: "/",
        //       label: "menu.Distribution2",
        //       icon: "i iwenjianjia",
        //       type: "L2",
        //       req: "distribution",
        //       radius: "hundredth",
        //       coin: "BTC",
        //       id: "33-2",
        //       assets: "BTC、ETH",
        //       introduce: "introduce.distribution1",
        //       interval: "menu.interval3",
        //     },
        //     {
        //       path: "/",
        //       label: "menu.Distribution3",
        //       icon: "i iwenjianjia",
        //       type: "L2",
        //       req: "distribution",
        //       radius: "units",
        //       coin: "BTC",
        //       id: "33-3",
        //       assets: "BTC、ETH",
        //       introduce: "introduce.distribution2",
        //       interval: "menu.interval3",
        //     },
        //     {
        //       path: "/",
        //       label: "menu.Distribution4",
        //       icon: "i iwenjianjia",
        //       type: "L2",
        //       req: "distribution",
        //       radius: "tens",
        //       coin: "BTC",
        //       id: "33-4",
        //       assets: "BTC、ETH",
        //       introduce: "introduce.distribution3",
        //       interval: "menu.interval3",
        //     },
        //     {
        //       path: "/",
        //       label: "menu.Distribution5",
        //       icon: "i iwenjianjia",
        //       type: "L2",
        //       req: "distribution",
        //       radius: "hundreds",
        //       coin: "BTC",
        //       id: "33-5",
        //       assets: "BTC、ETH",
        //       introduce: "introduce.distribution4",
        //       interval: "menu.interval3",
        //     },
        //     {
        //       path: "/",
        //       label: "menu.Distribution6",
        //       icon: "i iwenjianjia",
        //       type: "L2",
        //       req: "distribution",
        //       radius: "kilo",
        //       coin: "BTC",
        //       id: "33-6",
        //       assets: "BTC、ETH",
        //       introduce: "introduce.distribution5",
        //       interval: "menu.interval3",
        //     },
        //     {
        //       path: "/",
        //       label: "menu.Distribution7",
        //       icon: "i iwenjianjia",
        //       type: "L2",
        //       req: "distribution",
        //       radius: "myriad",
        //       coin: "BTC",
        //       id: "33-7",
        //       assets: "BTC、ETH",
        //       introduce: "introduce.distribution6",
        //       interval: "menu.interval3",
        //     },
        //   ],
        // },

        // {
        //   //主要交易所衍生数据
        //   label: "menu.derivatives",
        //   icon: "i i-zhuzhuangtu",
        //   id: "22--1",
        //   children: [
        //     {
        //       //具体数据
        //       path: "/",
        //       label: "menu.derivatives1",
        //       icon: "i iyonghuguanli_huaban",
        //       type: "L2",
        //       id: "22-1",
        //       children: [
        //         {
        //           //交易所日交易量
        //           path: "/",
        //           label: "menu.derivatives2",
        //           req: "derivatives",
        //           radius: "dailyVolume",
        //           coin: "BTC",
        //           id: "22-1-1",
        //           assets: "BTC、ETH",
        //           introduce: "introduce.dailyVolume",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           //交易所笔数变动
        //           path: "/",
        //           label: "menu.derivatives3",
        //           req: "derivatives",
        //           radius: "openInterest",
        //           coin: "BTC",
        //           id: "22-1-2",
        //           assets: "BTC、ETH",
        //           introduce: "introduce.openInterest",
        //           interval: "menu.interval3",
        //         },
        //       ],
        //     },
        //   ],
        // },

        // {//持有者币龄地址数/币数量分布图
        //   label: "menu.Currency",
        //   icon: "i ijiantou_zuoyouqiehuan",
        //   id: "28",
        //   children: [
        //     {
        //       // path: "/",
        //       label: "menu.Currency1",
        //       icon: "i iyonghuguanli_huaban",
        //       type: "L1",
        //       id: "25-1",
        //       children: [
        //         {
        //           // path: "/",
        //           label: "menu.Currency2",
        //           componentReq: "getDayBalanceData",
        //           radius: "btc",
        //           id: "25-1-1",
        //           value: 0,
        //           introduce: "introduce.getDayBalanceData",
        //           navigation: "balanceData",
        //           assets: "BTC",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           // path: "/",
        //           label: "menu.Currency3",
        //           componentReq: "getDayBalanceData",
        //           radius: "btc",
        //           id: "25-1-2",
        //           value: 0.01,
        //           introduce: "introduce.getDayBalanceData",
        //           navigation: "balanceData",
        //           assets: "BTC",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           // path: "/",
        //           label: "menu.Currency4",
        //           componentReq: "getDayBalanceData",
        //           radius: "btc",
        //           id: "25-1-3",
        //           value: 0.1,
        //           introduce: "introduce.getDayBalanceData",
        //           navigation: "balanceData",
        //           assets: "BTC",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           // path: "/",
        //           label: "menu.Currency5",
        //           componentReq: "getDayBalanceData",
        //           radius: "btc",
        //           id: "25-1-4",
        //           value: 1,
        //           introduce: "introduce.getDayBalanceData",
        //           navigation: "balanceData",
        //           assets: "BTC",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           // path: "/",
        //           label: "menu.Currency6",
        //           componentReq: "getDayBalanceData",
        //           radius: "btc",
        //           id: "25-1-5",
        //           value: 10,
        //           introduce: "introduce.getDayBalanceData",
        //           navigation: "balanceData",
        //           assets: "BTC",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           // path: "/",
        //           label: "menu.Currency7",
        //           componentReq: "getDayBalanceData",
        //           radius: "btc",
        //           id: "25-1-6",
        //           value: 100,
        //           introduce: "introduce.getDayBalanceData",
        //           navigation: "balanceData",
        //           assets: "BTC",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           // path: "/",
        //           label: "menu.Currency8",
        //           componentReq: "getDayBalanceData",
        //           radius: "btc",
        //           id: "25-1-7",
        //           value: 1000,
        //           introduce: "introduce.getDayBalanceData",
        //           navigation: "balanceData",
        //           assets: "BTC",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           // path: "/",
        //           label: "menu.Currency9",
        //           componentReq: "getDayBalanceData",
        //           radius: "btc",
        //           id: "25-1-8",
        //           value: 10000,
        //           introduce: "introduce.getDayBalanceData",
        //           navigation: "balanceData",
        //           assets: "BTC",
        //           interval: "menu.interval3",
        //         },
        //       ],
        //     },
        //     {
        //       // path: "/",
        //       label: "menu.Currency10",
        //       icon: "i iyonghuguanli_huaban",
        //       type: "L1",
        //       id: "25-2",
        //       children: [
        //         {
        //           // path: "/",
        //           label: "menu.Currency11",
        //           componentReq: "getDayBalanceAmountData",
        //           radius: "btc",
        //           id: "25-2-1",
        //           value: 0,
        //           introduce: "introduce.getDayBalanceAmountData",
        //           navigation: "balanceData",
        //           assets: "BTC",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           // path: "/",
        //           label: "menu.Currency12",
        //           componentReq: "getDayBalanceAmountData",
        //           radius: "btc",
        //           id: "25-2-2",
        //           value: 0.01,
        //           introduce: "introduce.getDayBalanceAmountData",
        //           navigation: "balanceData",
        //           assets: "BTC",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           // path: "/",
        //           label: "menu.Currency13",
        //           componentReq: "getDayBalanceAmountData",
        //           radius: "btc",
        //           id: "25-2-3",
        //           value: 0.1,
        //           introduce: "introduce.getDayBalanceAmountData",
        //           navigation: "balanceData",
        //           assets: "BTC",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           // path: "/",
        //           label: "menu.Currency14",
        //           componentReq: "getDayBalanceAmountData",
        //           radius: "btc",
        //           id: "25-2-4",
        //           value: 1,
        //           introduce: "introduce.getDayBalanceAmountData",
        //           navigation: "balanceData",
        //           assets: "BTC",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           // path: "/",
        //           label: "menu.Currency15",
        //           componentReq: "getDayBalanceAmountData",
        //           radius: "btc",
        //           id: "25-2-5",
        //           value: 10,
        //           introduce: "introduce.getDayBalanceAmountData",
        //           navigation: "balanceData",
        //           assets: "BTC",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           // path: "/",
        //           label: "menu.Currency16",
        //           componentReq: "getDayBalanceAmountData",
        //           radius: "btc",
        //           id: "25-2-6",
        //           value: 100,
        //           introduce: "introduce.getDayBalanceAmountData",
        //           navigation: "balanceData",
        //           assets: "BTC",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           // path: "/",
        //           label: "menu.Currency17",
        //           componentReq: "getDayBalanceAmountData",
        //           radius: "btc",
        //           id: "25-2-7",
        //           value: 1000,
        //           introduce: "introduce.getDayBalanceAmountData",
        //           navigation: "balanceData",
        //           assets: "BTC",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           // path: "/",
        //           label: "menu.Currency18",
        //           componentReq: "getDayBalanceAmountData",
        //           radius: "btc",
        //           id: "25-2-8",
        //           value: 10000,
        //           introduce: "introduce.getDayBalanceAmountData",
        //           navigation: "balanceData",
        //           assets: "BTC",
        //           interval: "menu.interval3",
        //         },
        //       ],
        //     },
        //   ],
        // },
        //#endregion
      ],
      //币种是ETH的时候的菜单
      ETHmenu: [
        {
          //链上数据
          label: "menu.onchain",
          icon: "i itubiao2",
          nested: "peers", //没有多层嵌套
          id: "E01",
          children: [
            {
              //地址
              label: "menu2.address",
              icon: "i izhexiantu-xianxing",
              id: "E01-1",
              children: [
                {
                  //地址统计
                  path: "/",
                  label: "menu.onchain2",
                  fullName: "menu.onchain2",
                  icon: "i igl-folderOpen",
                  componentReq: "address",
                  radius: "eth",
                  id: "E01-1-1",
                  introduce: "introduce.ethAddress",
                  navigation: "ethAddress",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest", //匿名用户
                },
                {
                  //盈利地址数
                  path: "/",
                  label: "menu2.profit",
                  fullName: "menu2.profit",
                  icon: "i igl-folderOpen",
                  componentReq: "profit",
                  radius: "eth",
                  id: "E01-1-3",
                  introduce: "introduce.profitAddress",
                  navigation: "profitEth",
                  assets: "ETH",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance",
                },
                {
                  //亏损地址数
                  path: "/",
                  label: "menu2.loss",
                  fullName: "menu2.loss",
                  icon: "i igl-folderOpen",
                  componentReq: "loss",
                  radius: "eth",
                  id: "E01-1-4",
                  introduce: "introduce.lossAddress",
                  navigation: "lossEth",
                  assets: "ETH",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance",
                },
                {
                  //盈利地址百分比
                  path: "/",
                  label: "menu2.profitPercent",
                  fullName: "menu2.profitPercent",
                  icon: "i igl-folderOpen",
                  componentReq: "profitPercent",
                  radius: "eth",
                  id: "E01-1-2",
                  introduce: "introduce.profitPercentEth",
                  navigation: "profitPercentEth",
                  assets: "ETH",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance",
                },

                {
                  //巨鲸地址跟踪 改为 巨鲸地址交易历史
                  path: "/",
                  label: "menu2.ethTopAddrMonitorList",
                  fullName: "menu2.ethTopAddrMonitorList",
                  icon: "i igl-folderOpen",
                  componentReq: "ethTopAddrMonitorList",
                  radius: "eth",
                  id: "E01-1-5",
                  introduce: "introduce.ethTopAddrMonitorList", //无
                  navigation: "ethTopAddrMonitorList",
                  assets: "ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                {
                  //巨鲸列表 改为 巨鲸地址列表
                  path: "/",
                  label: "menu2.onchain2",
                  fullName: "menu2.onchain2",
                  icon: "i igl-folderOpen",
                  componentReq: "ethTopAddrList",
                  radius: "eth",
                  id: "E01-1-6",
                  introduce: "introduce.getTopList",
                  navigation: "ethTopAddrList", //导航组件名称
                  assets: "ETH",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest", //匿名用户
                },
              ],
            },
            {
              //网络
              label: "menu2.Network",
              icon: "i izhexiantu-xianxing",
              id: "E02-1",
              children: [
                {
                  //日交易统计 更改名字 交易统计
                  path: "/",
                  label: "menu2.onchain19",
                  fullName: "menu2.onchain19",
                  icon: "i igl-folderOpen",
                  componentReq: "ETHVolume",
                  radius: "btc",
                  id: "E02-1-1",
                  introduce: "introduce.ETHVolume",
                  navigation: "Fees", //导航组件名称
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest", //匿名用户
                },
                {
                  //交易费率乘数
                  path: "/",
                  label: "menu2.frm",
                  fullName: "menu2.frm",
                  icon: "i igl-folderOpen",
                  componentReq: "frm",
                  radius: "eth",
                  id: "E02-1-2",
                  introduce: "introduce.frm",
                  navigation: "frmEth",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
                {
                  //燃烧量
                  path: "/",
                  label: "menu2.burnedSupply",
                  fullName: "menu2.burnedSupply",
                  icon: "i igl-folderOpen",
                  componentReq: "burnedSupply",
                  radius: "eth",
                  id: "E02-1-3",
                  introduce: "introduce.burnedSupplyEth",
                  navigation: "burnedSupplyEth",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
                {
                  //发行量
                  path: "/",
                  label: "menu2.mintedSupply",
                  fullName: "menu2.mintedSupply",
                  icon: "i igl-folderOpen",
                  componentReq: "mintedSupply",
                  radius: "eth",
                  id: "E02-1-4",
                  introduce: "introduce.mintedSupplyEth",
                  navigation: "mintedSupplyEth",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
                {
                  //新币发行量
                  path: "/",
                  label: "menu2.issuance",
                  fullName: "menu2.issuance",
                  icon: "i igl-folderOpen",
                  componentReq: "issuance",
                  radius: "eth",
                  id: "E02-1-5",
                  introduce: "introduce.issuanceEth",
                  navigation: "issuanceEth",
                  assets: "ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
                {
                  //流通供应量
                  path: "/",
                  label: "menu.technology21",
                  fullName: "menu.technology21",
                  icon: "i igl-folderOpen",
                  componentReq: "csupply",
                  radius: "btc",
                  id: "E02-1-6",
                  introduce: "introduce.csupply",
                  navigation: "csupply", //导航组件名称
                  assets: "BTC、ETH",
                  interval: "menu.interval3", //历史数据
                  type: "L1",
                  authority: "guest", //匿名用户
                },
                {
                  //抵押奖励
                  path: "/",
                  label: "menu2.reward",
                  fullName: "menu2.reward",
                  icon: "i igl-folderOpen",
                  componentReq: "reward",
                  radius: "eth",
                  id: "E02-1-7",
                  introduce: "introduce.reward",
                  navigation: "reward",
                  assets: "ETH",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest", //匿名用户
                },
                {
                  //通货膨胀率
                  path: "/",
                  label: "menu2.inflationRate",
                  fullName: "menu2.inflationRate",
                  icon: "i igl-folderOpen",
                  componentReq: "inflactionRate",
                  radius: "eth",
                  id: "E02-1-8",
                  introduce: "introduce.inflactionRateEth",
                  navigation: "inflactionRateEth",
                  assets: "ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
                {
                  //新合约数
                  path: "/",
                  label: "menu2.cnew",
                  fullName: "menu2.cnew",
                  icon: "i igl-folderOpen",
                  componentReq: "cnew",
                  radius: "eth",
                  id: "E02-1-9",
                  introduce: "introduce.cnew",
                  navigation: "cnew",
                  assets: "ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                {
                  //新合约地址
                  path: "/",
                  label: "menu2.newContract",
                  fullName: "menu2.newContract",
                  icon: "i igl-folderOpen",
                  componentReq: "newContract",
                  radius: "eth",
                  id: "E02-1-10",
                  introduce: "introduce.newContract", //无
                  navigation: "newContract",
                  assets: "ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                {
                  //大额交易
                  path: "/",
                  label: "menu2.onchain1",
                  fullName: "menu2.onchain1",
                  icon: "i igl-folderOpen",
                  componentReq: "ethbigtxcount",
                  radius: "eth",
                  id: "E02-1-11",
                  introduce: "introduce.btcbigtxcount",
                  navigation: "bigDeals",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest", //匿名用户
                },
              ],
            },
            {
              //代币
              label: "menu2.Token",
              icon: "i izhexiantu-xianxing",
              id: "E03-1",
              children: [
                {
                  //erc20 token 日交易量 改为代币交易量
                  path: "/",
                  label: "menu2.large6",
                  fullName: "menu2.large6",
                  icon: "i igl-folderOpen",
                  componentReq: "ETHTokenVolume",
                  radius: "eth",
                  id: "E03-1-1",
                  introduce: "introduce.ETHTokenVolume",
                  navigation: "ercVolume",
                  assets: "ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },

                {
                  //erc20 token 大额交易监控 改为 代币大额交易
                  path: "/",
                  label: "menu2.large5",
                  fullName: "menu2.ercBigDeals",
                  icon: "i igl-folderOpen",
                  componentReq: "ETHTokenBigtx",
                  radius: "eth",
                  id: "E03-1-2",
                  introduce: "introduce.ETHTokenBigtx",
                  navigation: "ercBigDeals",
                  assets: "ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
              ],
            },
            {
              //盈亏
              label: "menu2.ProfitLoss",
              icon: "i izhexiantu-xianxing",
              id: "E04-1",
              children: [
                {
                  //流通市值
                  path: "/",
                  label: "menu2.marketcap",
                  fullName: "menu2.marketcap2",
                  icon: "i igl-folderOpen",
                  componentReq: "marketcap",
                  radius: "eth",
                  id: "E04-1-1",
                  introduce: "introduce.marketcap",
                  navigation: "marketcapEth",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest",
                },
                {
                  //已实现流通市值
                  path: "/",
                  label: "menu2.rcap",
                  fullName: "menu2.rcap2",
                  icon: "i igl-folderOpen",
                  componentReq: "rcap",
                  radius: "eth",
                  id: "E04-1-4",
                  introduce: "introduce.rcapEth",
                  navigation: "rcapEth",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
                {
                  //流通市值-已实现流通市值比 改为 MVRV Ratio
                  path: "/",
                  label: "menu2.mvrvRatio",
                  fullName: "menu2.mvrvRatio2",
                  icon: "i igl-folderOpen",
                  componentReq: "mvrvRatio",
                  radius: "eth",
                  id: "E04-1-11",
                  introduce: "introduce.MVRV",
                  navigation: "mvrvRatioEth",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
                {
                  //已实现价格
                  path: "/",
                  label: "menu2.rprice",
                  fullName: "menu2.rprice",
                  icon: "i igl-folderOpen",
                  componentReq: "rprice",
                  radius: "eth",
                  id: "E04-1-5",
                  introduce: "introduce.realizedPrice",
                  navigation: "rpriceEth",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
                {
                  //市值/交易价值比 NVT Ratio 改为 市盈率
                  path: "/",
                  label: "menu2.nvtRatio",
                  fullName: "menu2.nvtRatio2",
                  icon: "i igl-folderOpen",
                  componentReq: "nvtRatio",
                  radius: "eth",
                  id: "E04-1-2",
                  introduce: "introduce.nvtRatio",
                  navigation: "nvtRatioEth",
                  assets: "ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
                {
                  //流通速度
                  path: "/",
                  label: "menu2.velocity",
                  fullName: "menu2.velocity",
                  icon: "i igl-folderOpen",
                  componentReq: "velocity",
                  radius: "eth",
                  id: "E04-1-3",
                  introduce: "introduce.velocity",
                  navigation: "velocityEth",
                  assets: "ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
                {
                  //未实现的净收益量
                  path: "/",
                  label: "menu2.relativeUProfit",
                  fullName: "menu2.relativeUProfit",
                  icon: "i igl-folderOpen",
                  componentReq: "relativeUProfit",
                  radius: "eth",
                  id: "E04-1-7",
                  introduce: "introduce.uprofit",
                  navigation: "relativeUProfitEth",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
                {
                  //未实现的净亏损量
                  path: "/",
                  label: "menu2.relativeULoss",
                  fullName: "menu2.relativeULoss",
                  icon: "i igl-folderOpen",
                  componentReq: "relativeULoss",
                  radius: "eth",
                  id: "E04-1-8",
                  introduce: "introduce.uloss",
                  navigation: "relativeULossEth",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },

                {
                  //未实现的净收益损失比
                  path: "/",
                  label: "menu2.nupl",
                  fullName: "menu2.nupl2",
                  icon: "i igl-folderOpen",
                  componentReq: "nupl",
                  radius: "eth",
                  id: "E04-1-6",
                  introduce: "introduce.nupl",
                  navigation: "nuplEth",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },

                {
                  //长持者未实现的净收益量 修改为 长持者未实现的净收益损失比
                  path: "/",
                  label: "menu2.lthNUPL",
                  fullName: "menu2.lthNUPL2",
                  icon: "i igl-folderOpen",
                  componentReq: "lthNUPL",
                  radius: "eth",
                  id: "E04-1-9",
                  introduce: "introduce.lthnupl",
                  navigation: "lthNUPLEth",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance",
                },
                {
                  //短持者未实现的净亏损量 改为 短持者未实现的净亏损损失比
                  path: "/",
                  label: "menu2.sthNUPL",
                  fullName: "menu2.sthNUPL2",
                  icon: "i igl-folderOpen",
                  componentReq: "sthNUPL",
                  radius: "eth",
                  id: "E04-1-10",
                  introduce: "introduce.sthnupl",
                  navigation: "sthNUPLEth",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L3",
                  authority: "advance",
                },
              ],
            },
            {
              //币龄
              label: "menu2.Lifetime",
              icon: "i izhexiantu-xianxing",
              id: "E05-1",
              children: [
                {
                  //币天销毁量
                  path: "/",
                  label: "menu2.cdd",
                  fullName: "menu2.cdd2",
                  icon: "i igl-folderOpen",
                  componentReq: "cdd",
                  radius: "eth",
                  id: "E05-1-2",
                  introduce: "introduce.CDD",
                  navigation: "CDDETH",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                {
                  //币天销毁量分布 修改为BTC一样  币天销毁量年龄分布
                  path: "/",
                  label: "menu2.cddwave",
                  fullName: "menu2.cddwave2",
                  icon: "i igl-folderOpen",
                  componentReq: "cddwave",
                  radius: "eth",
                  id: "E05-1-3",
                  introduce: "introduce.soag",
                  navigation: "cddwaveEth",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                {
                  //已花费输出平均寿命
                  path: "/",
                  label: "menu2.asol",
                  fullName: "menu2.asol2",
                  icon: "i igl-folderOpen",
                  componentReq: "asol",
                  radius: "eth",
                  id: "E05-1-4",
                  introduce: "introduce.asol",
                  navigation: "asolEth",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                {
                  //已花费输出休眠平均天数
                  path: "/",
                  label: "menu2.dormancy",
                  fullName: "menu2.dormancy",
                  icon: "i igl-folderOpen",
                  componentReq: "dormancy",
                  radius: "eth",
                  id: "E05-1-5",
                  introduce: "introduce.dormancy",
                  navigation: "dormancyEth",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                {
                  //活跃度
                  path: "/",
                  label: "menu2.liveliness",
                  fullName: "menu2.liveliness",
                  icon: "i igl-folderOpen",
                  componentReq: "liveliness",
                  radius: "eth",
                  id: "E05-1-6",
                  introduce: "introduce.Liveliness",
                  navigation: "livelinessEth",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
              ],
            },
            {
              //比率
              label: "menu.Ratio",
              icon: "i izhexiantu-xianxing",
              id: "E06-1",
              children: [
                {
                  //已花费输出盈利比
                  path: "/",
                  label: "menu2.sopr",
                  fullName: "menu2.sopr2",
                  icon: "i igl-folderOpen",
                  componentReq: "sopr",
                  radius: "eth",
                  id: "E06-1-1",
                  introduce: "introduce.soprEth",
                  navigation: "soprEth",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L1",
                  authority: "guest",
                },
                {
                  //盈利供应量
                  path: "/",
                  label: "menu2.supplyprofit",
                  fullName: "menu2.supplyprofit",
                  icon: "i igl-folderOpen",
                  componentReq: "supplyprofit",
                  radius: "eth",
                  id: "E06-1-2",
                  introduce: "introduce.supplyProfitEth",
                  navigation: "supplyProfitEth",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
                {
                  //盈利亏损量
                  path: "/",
                  label: "menu2.supplyloss",
                  fullName: "menu2.supplyloss",
                  icon: "i igl-folderOpen",
                  componentReq: "supplyLoss",
                  radius: "eth",
                  id: "E06-1-3",
                  introduce: "introduce.supplyLossEth",
                  navigation: "supplyLossEth",
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },

                {
                  //盈利百分比
                  path: "/",
                  label: "menu2.supplyprofitPercent",
                  fullName: "menu2.supplyprofitPercent",
                  icon: "i igl-folderOpen",
                  componentReq: "supplyprofitPercent",
                  radius: "eth",
                  id: "E06-1-4",
                  introduce: "introduce.supplyProfitPercentEth",
                  navigation: "supplyProfitPercentEth", //ProfitPercentEthsupply
                  assets: "BTC、ETH",
                  interval: "menu.interval3",
                  type: "L2",
                  authority: "registered",
                },
              ],
            },
            {
              //持有者分布
              label: "menu2.Holder",
              icon: "i izhexiantu-xianxing",
              id: "E07-1",
              children: [
                {
                  //按余额划分
                  label: "menu2.balanceGroup",
                  icon: "i izhexiantu-xianxing",
                  id: "E07-1-1",
                  children: [
                    {
                      //按余额分段的地址数分布 改为 地址数分布
                      path: "/",
                      label: "menu2.distribution",
                      fullName: "menu2.distribution",
                      icon: "i igl-folderOpen",
                      componentReq: "distribution",
                      radius: "eth",
                      id: "E07-1-1-1",
                      introduce: "introduce.balanceDistribution",
                      navigation: "distributionEth",
                      assets: "ETH",
                      interval: "menu.interval3",
                      type: "L2",
                      authority: "registered", //注册用户
                    },
                    {
                      //持有者地址的供应分布 改为 币数量分布
                      path: "/",
                      label: "menu2.supplyDistribution",
                      fullName: "menu2.supplyDistribution",
                      icon: "i igl-folderOpen",
                      componentReq: "supplyDistribution",
                      radius: "eth",
                      id: "E07-1-1-2",
                      introduce: "introduce.balanceDistribution",
                      navigation: "supplyDistributionEth",
                      assets: "ETH",
                      interval: "menu.interval3",
                      type: "L3",
                      authority: "advance",
                    },
                  ],
                },
              ],
            },
          ],
        },
        // {
        //   //链上数据
        //   label: "menu2.onchain",
        //   icon: "i itubiao2",
        //   nested: "peers", //判断是否多层嵌套
        //   id: "01",
        //   children: [
        //     // {//地址对应标记持有者名称关系列表 告知不显示未定义该指标
        //     //   path: "/",
        //     //   label: "menu2.onchain18",
        //     //   icon: "i igl-folderOpen",
        //     //   componentReq: "ethTags",
        //     //   radius: "eth",
        //     //   id: "23-32",
        //     //   introduce: "introduce.ethTags",
        //     //   navigation: "btctags", //导航组件名称
        //     //   assets: "BTC、ETH",
        //     //   interval: "menu.interval3",
        //     // },

        //   ],
        // },
        {
          //市场技术指标 改为 市场指标
          label: "menu.market",
          icon: "i i-zhuzhuangtu",
          nested: "peers", //判断是否多层嵌套
          id: "1",
          children: [
            // {//MVRV
            //   path: "/",
            //   label: "menu.technology1",
            //   icon: "i igl-folderOpen",
            //   req: "market",
            //   radius: `MVRV`,
            //   coin: "BTC",
            //   id: "23-1",
            //   introduce: "introduce.MVRV",
            //   assets: "BTC、ETH、LTC",
            //   interval: "menu.interval3",
            // },
            // {
            //   path: "/",
            //   label: "menu.technology2",
            //   icon: "i igl-folderOpen",
            //   req: "market",
            //   radius: "MVRVZ",
            //   coin: "BTC",
            //   id: "1-2",
            //   introduce: "introduce.MVRVZ",
            //   assets: "BTC、ETH、LTC",
            //   interval: "menu.interval3",
            // },
            // {
            //   path: "/",
            //   label: "menu.technology3",
            //   icon: "i igl-folderOpen",
            //   req: "market",
            //   radius: "NVTRatio",
            //   coin: "BTC",
            //   id: "1-3",
            //   introduce: "introduce.NVTRatio",
            //   assets: "BTC、ETH、LTC",
            //   interval: "menu.interval3",
            // },
            // {
            //   path: "/",
            //   label: "menu.technology4",
            //   icon: "i igl-folderOpen",
            //   req: "market",
            //   radius: "NVTSignal",
            //   coin: "BTC",
            //   id: "1-4",
            //   introduce: "introduce.NVTSignal",
            //   assets: "BTC、ETH、LTC",
            //   interval: "menu.interval3",
            // },

            // {//天针
            //   path: "/",
            //   label: "menu2.technology8",
            //   icon: "i igl-folderOpen",
            //   componentReq: "天针",
            //   radius: "btc",
            //   id: "1-10",
            //   introduce: "introduce.DaysNeedle",
            //   navigation: "DaysNeedle", //导航组件名称
            //   assets: "无",
            //   interval: "menu.interval3",
            // },
            {
              //江卓尔60日累计涨幅
              path: "/",
              label: "menu2.technology6",
              fullName: "menu2.jzr60",
              icon: "i igl-folderOpen",
              componentReq: "jzr60",
              radius: "ETH",
              id: "1-6",
              // conditions: "arh", //不同请求方式筛选条件
              introduce: "introduce.jzr60",
              navigation: "jzr60",
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
            // {
            //   path: "/",
            //   label: "menu2.technology7",
            //   icon: "i igl-folderOpen",
            //   componentReq: "arh99",
            //   radius: "ETH",
            //   id: "1-7",
            //   navigation: "arh999",
            //   // conditions: "arh", //不同请求方式筛选条件
            //   introduce: "introduce.arh999",
            //   assets: "BTC、ETH",
            //   interval: "menu.interval3",
            // },
            {
              //2年移动平均价格乘数
              path: "/",
              label: "menu2.technology11",
              fullName: "menu2.ma730",
              icon: "i igl-folderOpen",
              componentReq: "ma730",
              radius: "eth",
              id: "1-11",
              introduce: "introduce.ma730",
              navigation: "ma730ETH", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
            // {
            //   //日K线 删除不显示
            //   path: "/",
            //   label: "menu2.technology5",
            //   icon: "i igl-folderOpen",
            //   componentReq: "OHLCPrice",
            //   radius: "BTC",
            //   id: "1-5",
            //   introduce: "introduce.OHLCPrice",
            //   navigation: "ETH",
            //   assets: "BTC, ETH",
            //   interval: "menu.interval3",
            //   type: "L2",
            //   authority: "registered", //注册用户
            // },
            {
              //PI周期顶指标 ETH
              path: "/",
              label: "menu2.PiCycleTopIndicator",
              fullName: "menu2.PiCycleTopIndicator",
              icon: "i igl-folderOpen",
              componentReq: "PiCycleTopIndicator",
              radius: "eth",
              id: "1-12",
              introduce: "introduce.PiCycleTopIndicator",
              navigation: "piCycleTopEth", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest",
            },
            {
              //黄金比例乘数 ETH
              path: "/",
              label: "menu2.goldenRatioMult",
              fullName: "menu2.goldenRatioMult",
              icon: "i igl-folderOpen",
              componentReq: "goldenRatioMult",
              radius: "eth",
              id: "1-13",
              introduce: "introduce.goldenRatioMult",
              navigation: "goldenRatioMultEth", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
          ],
        },
        {
          //交易所数据
          label: "menu.exchange",
          icon: "i itubiao2",
          nested: "peers", //判断是否多层嵌套
          id: "E03",
          children: [
            {
              //资金费率
              path: "/",
              label: "menu.technology13",
              fullName: "menu.technology13", //全名
              icon: "i igl-folderOpen",
              componentReq: "fundingRateETH",
              radius: "eth",
              id: "E03-5",
              introduce: "introduce.fundingRate",
              navigation: "fundingRateETH", //导航组件名称
              assets: "BTCUSDT、ETHUSDT",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //注册用户
            },
            {
              //未平仓合约数
              path: "/",
              label: "menu.technology14",
              fullName: "menu.technology14", //全名
              icon: "i igl-folderOpen",
              componentReq: "openInterestETH",
              radius: "eth",
              id: "E03-6",
              introduce: "introduce.openInterest",
              navigation: "openInterestETH", //导航组件名称
              assets: "BTCUSDT、ETHUSDT",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //合约主动买入量
              path: "/",
              label: "menu.technology15",
              fullName: "menu.technology15", //全名
              icon: "i igl-folderOpen",
              componentReq: "takerlongshortRatioETH",
              radius: "eth",
              id: "E03-7",
              introduce: "introduce.takerlongshortRatio",
              navigation: "takerlongshortRatioETH", //导航组件名称
              assets: "BTCUSDT、ETHUSDT",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },

            {
              //时区购买力
              path: "/",
              label: "menu.tzbp",
              fullName: "menu.tzbp",
              icon: "i igl-folderOpen",
              componentReq: "tzbpEth",
              radius: "btc",
              id: "E03-1",
              introduce: "introduce.tzbp",
              navigation: "tzbpEth", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            {
              //买入大单挂单
              path: "/",
              label: "menu.bobp",
              fullName: "menu.bobp",
              icon: "i igl-folderOpen",
              componentReq: "bobp",
              radius: "btc",
              id: "E03-2",
              introduce: "introduce.bobp",
              navigation: "bobpEth", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            {
              //卖出大单挂单
              path: "/",
              label: "menu.bosp",
              fullName: "menu.bosp",
              icon: "i igl-folderOpen",
              componentReq: "bosp",
              radius: "btc",
              id: "E03-3",
              introduce: "introduce.bobp",
              navigation: "bospEth", //导航组件名称
              assets: "BTC、ETH",
              interval: "menu.interval3",
              type: "L3",
              authority: "advance",
            },
            // {
            //   //成交量分布图
            //   path: "/",
            //   label: "menu.volumeProfile",
            //   fullName: "menu.volumeProfile", //全名
            //   icon: "i igl-folderOpen",
            //   componentReq: "volumeProfileETH",
            //   radius: "ETH",
            //   id: "E03-8",
            //   introduce: "introduce.volumeProfile",
            //   navigation: "volumeProfileETH", //导航组件名称
            //   assets: "BTCUSDT、ETHUSDT",
            //   interval: "menu.interval3",
            //   type: "L3",
            //   authority: "advance",
            // },
            // {
            //   //交易所余额
            //   path: "/",
            //   label: "menu.exchange10",
            //   fullName: "menu.exchange10",
            //   icon: "i igl-folderOpen",
            //   componentReq: "exchange",
            //   radius: "btc",
            //   id: "E03-4",
            //   introduce: "introduce.exchange1",
            //   navigation: "exchangeETH", //导航组件名称
            //   assets: "BTC、ETH",
            //   interval: "menu.interval3",
            //   type: "L2",
            //   authority: "registered",
            // },
          ],
        },
        //#region
        // {//地址 活动地址 新增地址
        //   label: "menu2.address",
        //   icon: "i iqianbao",
        //   id: "4",
        //   children: [
        //     {
        //       path: "/",
        //       label: "menu2.address1",
        //       icon: "i 24igl-folderOpen",
        //       type: "L1",
        //       id: "4-1",
        //       children: [
        //         {
        //           // path: "/1",
        //           label: `menu2.address2`,
        //           req: "activeAddress",
        //           radius: "btc",
        //           id: "4-1-1",
        //           introduce: "introduce.activeAddress",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           // path: "/2",
        //           label: "menu2.address3",
        //           req: "sendingAddress",
        //           radius: "btc",
        //           id: "4-1-2",
        //           introduce: "introduce.sendingAddress",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           // path: "/3",
        //           label: "menu2.address4",
        //           req: "receivingAddress",
        //           radius: "btc",
        //           id: "4-1-3",
        //           introduce: "introduce.receivingAddress",
        //           interval: "menu.interval3",
        //         },
        //       ],
        //     },
        //     {
        //       path: "/",
        //       label: "menu2.address5",
        //       icon: "i 24igl-folderOpen",
        //       type: "L1",
        //       id: "4-2",
        //       children: [
        //         {
        //           path: "/1",
        //           label: "menu2.address6",
        //           req: "newAddress",
        //           radius: "btc",
        //           id: "4-2-1",
        //           introduce: "introduce.newAddress",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           path: "/2",
        //           label: "menu2.address7",
        //           req: "totalAddress",
        //           radius: "btc",
        //           id: "4-2-2",
        //           introduce: "introduce.totalAddress",
        //           interval: "menu.interval3",
        //         },
        //       ],
        //     },
        //   ],
        // },

        // {//交易汇总
        //   label: "menu2.transactions",
        //   icon: "i ijiantou_zuoyouqiehuan",
        //   id: "20",
        //   children: [
        //     {
        //       // path: "/",
        //       label: "menu2.transactions4",
        //       icon: "i iyonghuguanli_huaban",
        //       type: "L1",
        //       id: "20-2",
        //       children: [
        //         {
        //           // path: "/",
        //           label: "menu2.transactions5",
        //           req: "transactions",
        //           radius: "btc",
        //           id: "20-2-1",
        //           introduce: "introduce.transactions",
        //           assets: "BTC、ETH、LTC",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           // path: "/",
        //           label: "menu2.transactions6",
        //           req: "transrate",
        //           radius: "btc",
        //           id: "20-2-2",
        //           introduce: "introduce.transrate",
        //           assets: "BTC、ETH、LTC",
        //           interval: "menu.interval3",
        //         },
        //       ],
        //     },
        //   ],
        // },

        // {//分配数据
        //   label: "menu2.Distribution",
        //   icon: "i izhexiantu_o",
        //   nested: "peers", //判断是否多层嵌套
        //   id: "3",
        //   children: [
        //     {
        //       path: "/",
        //       label: "menu2.Distribution1",
        //       icon: "i iwenjianjia",
        //       type: "L2",
        //       req: "distribution",
        //       radius: "tenths",
        //       coin: "BTC",
        //       id: "3-1",
        //       assets: "BTC、ETH",
        //       introduce: "introduce.distribution",
        //       interval: "menu.interval3",
        //     },
        //     {
        //       path: "/",
        //       label: "menu2.Distribution2",
        //       icon: "i iwenjianjia",
        //       type: "L2",
        //       req: "distribution",
        //       radius: "hundredth",
        //       coin: "BTC",
        //       id: "3-2",
        //       assets: "BTC、ETH",
        //       introduce: "introduce.distribution1",
        //       interval: "menu.interval3",
        //     },
        //     {
        //       path: "/",
        //       label: "menu2.Distribution3",
        //       icon: "i iwenjianjia",
        //       type: "L2",
        //       req: "distribution",
        //       radius: "units",
        //       coin: "BTC",
        //       id: "3-3",
        //       assets: "BTC、ETH",
        //       introduce: "introduce.distribution2",
        //       interval: "menu.interval3",
        //     },
        //     {
        //       path: "/",
        //       label: "menu2.Distribution4",
        //       icon: "i iwenjianjia",
        //       type: "L2",
        //       req: "distribution",
        //       radius: "tens",
        //       coin: "BTC",
        //       id: "3-4",
        //       assets: "BTC、ETH",
        //       introduce: "introduce.distribution3",
        //       interval: "menu.interval3",
        //     },
        //     {
        //       path: "/",
        //       label: "menu2.Distribution5",
        //       icon: "i iwenjianjia",
        //       type: "L2",
        //       req: "distribution",
        //       radius: "hundreds",
        //       coin: "BTC",
        //       id: "3-5",
        //       assets: "BTC、ETH",
        //       introduce: "introduce.distribution4",
        //       interval: "menu.interval3",
        //     },
        //     {
        //       path: "/",
        //       label: "menu2.Distribution6",
        //       icon: "i iwenjianjia",
        //       type: "L2",
        //       req: "distribution",
        //       radius: "kilo",
        //       coin: "BTC",
        //       id: "3-6",
        //       assets: "BTC、ETH",
        //       introduce: "introduce.distribution5",
        //       interval: "menu.interval3",
        //     },
        //     {
        //       path: "/",
        //       label: "menu2.Distribution7",
        //       icon: "i iwenjianjia",
        //       type: "L2",
        //       req: "distribution",
        //       radius: "myriad",
        //       coin: "BTC",
        //       id: "3-7",
        //       assets: "BTC、ETH",
        //       introduce: "introduce.distribution6",
        //       interval: "menu.interval3",
        //     },
        //   ],
        // },

        // {//主要交易所衍生数据
        //   label: "menu2.derivatives",
        //   icon: "i i-zhuzhuangtu",
        //   id: "22--1",
        //   children: [
        //     {//具体数据
        //       path: "/",
        //       label: "menu2.derivatives1",
        //       icon: "i iyonghuguanli_huaban",
        //       type: "L2",
        //       id: "22-1",
        //       children: [
        //         {
        //           path: "/",
        //           label: "menu2.derivatives2",
        //           req: "derivatives",
        //           radius: "dailyVolume",
        //           coin: "BTC",
        //           id: "22-1-1",
        //           assets: "BTC、ETH",
        //           introduce: "menu.dailyVolume",
        //           interval: "menu.interval3",
        //         },
        //         {
        //           path: "/",
        //           label: "menu2.derivatives3",
        //           req: "derivatives",
        //           radius: "openInterest",
        //           coin: "BTC",
        //           id: "22-1-2",
        //           assets: "BTC、ETH",
        //           introduce: "menu.openInterest",
        //           interval: "menu.interval3",
        //         },
        //       ],
        //     },
        //   ],
        // },
        //#endregion
      ],
      //稳定币导航
      stableMenu: [
        {
          //流通量

          label: "menu2.flux",
          icon: "i izhexiantu-xianxing",
          nested: "peers", //判断是否多层嵌套multistage
          id: "w1",
          children: [
            {
              //总流通量
              path: "/",
              label: "menu2.cstotal",
              fullName: "menu2.cstotal",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "eth",
              id: "w1-1",
              introduce: "introduce.circulationTotalCSupply",
              navigation: "circulationTotalCSupply",
              assets: "USDC、USDT、BUSD",
              interval: "menu.interval3", //历史数据
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //USDC
              path: "/",
              label: "menu2.csusdc",
              fullName: "menu2.csusdc",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "eth",
              id: "w1-2",
              introduce: "introduce.circulationUSDC", //无介绍
              navigation: "circulationUSDC",
              assets: "USDC",
              interval: "menu.interval3", //历史数据
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //USDT
              path: "/",
              label: "menu2.csusdt",
              fullName: "menu2.csusdt",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "eth",
              id: "w1-3",
              introduce: "introduce.circulationUSDT", //无介绍
              navigation: "circulationUSDT",
              assets: "USDT",
              interval: "menu.interval3", //历史数据
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //BUSD
              // path: "/",
              label: "menu2.csbusd",
              fullName: "menu2.csbusd",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "eth",
              id: "w1-4",
              introduce: "introduce.circulationBUSD", //无介绍
              navigation: "circulationBUSD",
              assets: "BUSD",
              interval: "menu.interval3", //历史数据
              type: "L1",
              authority: "guest", //匿名用户
            },
          ],
        },
        {
          //铸造

          label: "menu2.casting",
          icon: "i izhexiantu-xianxing",
          nested: "peers", //判断是否多层嵌套multistage
          id: "w2",
          children: [
            // {
            //   //USDC铸造量
            //   path: "/",
            //   label: "menu2.USDCCasting",
            //   fullName: "menu2.USDCCasting2",
            //   icon: "i igl-folderOpen",
            //   componentReq: "",
            //   radius: "USDC",
            //   id: "w2-2",
            //   introduce: "introduce.USDCCasting", //无介绍
            //   navigation: "mintedUSDC",
            //   assets: "USDC",
            //   interval: "menu.interval3", //历史数据
            //   type: "L3",
            //   authority: "advance",
            // },
            {
              //USDT铸造量
              path: "/",
              label: "menu2.USDTCasting",
              fullName: "menu2.USDTCasting2",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "USDT",
              id: "w2-1",
              introduce: "introduce.USDTCasting", //无介绍
              navigation: "mintedUSDT",
              assets: "USDT",
              interval: "menu.interval3", //历史数据
              type: "L3",
              authority: "advance", 
            },

            {
              //BUSD铸造量
              path: "/",
              label: "menu2.BUSDCasting",
              fullName: "menu2.BUSDCasting2",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "BUSD",
              id: "w2-3",
              introduce: "introduce.BUSDCasting", //无介绍
              navigation: "mintedBUSD",
              assets: "BUSD",
              interval: "menu.interval3", //历史数据
              type: "L3",
              authority: "advance",
            },
          ],
        },
        {
          //交易量
          label: "menu2.TradingVolume",
          icon: "i izhexiantu-xianxing",
          nested: "peers", //判断是否多层嵌套multistage
          id: "w3",
          children: [
            {
              //USDC交易量
              path: "/",
              label: "menu2.usdc",
              fullName: "menu2.usdc2",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "eth",
              id: "w3-1",
              introduce: "introduce.dayUsdc", //无介绍
              navigation: "USDC",
              assets: "USDC",
              interval: "menu.interval3", //无介绍
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //USDT交易量
              path: "/",
              label: "menu2.usdt",
              fullName: "menu2.usdt2",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "eth",
              id: "w3-2",
              introduce: "introduce.dayUsdt", //无介绍
              navigation: "USDT",
              assets: "USDT",
              interval: "menu.interval3", //无
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //BUSD交易量
              path: "/",
              label: "menu2.busd",
              fullName: "menu2.busd2",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "eth",
              id: "w3-3",
              introduce: "introduce.dayBusd", //无介绍
              navigation: "BUSD",
              assets: "BUSD",
              interval: "menu.interval3", //1天
              type: "L1",
              authority: "guest", //匿名用户
            },
          ],
        },
        {
          //大额交易监控

          label: "menu2.Bulk",
          icon: "i izhexiantu-xianxing",
          nested: "peers", //判断是否多层嵌套multistage
          id: "w4",
          children: [
            {
              //USDC大额交易
              path: "/",
              label: "menu2.USDCMonitoring",
              fullName: "menu2.USDCMonitoring2",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "eth",
              id: "w4-1",
              introduce: "introduce.bigUsdc",
              navigation: "USDCMonitoring",
              assets: "USDC",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册
            },
            {
              //USDT大额交易
              path: "/",
              label: "menu2.USDTMonitoring",
              fullName: "menu2.USDTMonitoring2",
              icon: "i igl-folderOpen",
              componentReq: "",
              radius: "eth",
              id: "w4-2",
              introduce: "introduce.bigUsdt",
              navigation: "USDTMonitoring",
              assets: "USDT",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册
            },
            // {
            //   //BUSD大额交易
            //   path: "/",
            //   label: "menu2.BUSDMonitoring",
            //   fullName: "menu2.BUSDMonitoring2",
            //   icon: "i igl-folderOpen",
            //   componentReq: "",
            //   radius: "eth",
            //   id: "w4-3",
            //   introduce: "introduce.bigBusd",
            //   navigation: "BUSDMonitoring",
            //   assets: "BUSD",
            //   interval: "menu.interval3", //1天
            //   type: "L2",
            //   authority: "registered", //注册
            // },
          ],
        },
      ],
      //宏观经济指标导航
      macroscopicMenu: [
        {
          //货币金融

          label: "Macroscopic.monetaryFinance",
          icon: "i ichanpin-huobijinrongfuwu",
          nested: "peers", //判断是否多层嵌套multistage
          id: "H1",
          children: [
            {
              //货币供应量
              path: "/",
              label: "menu.MoneyStockMeasures",
              fullName: "menu.MoneyStockMeasures", //全名
              icon: "i igl-folderOpen",
              componentReq: "MoneyStockMeasures",
              id: "H1-1",
              introduce: "introduce.MoneyStockMeasures",
              navigation: "MoneyStockMeasures",
              assets: "无",
              interval: "home.no",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //外汇--实时汇率
              path: "/",
              label: "menu.exchangeRate",
              fullName: "menu.exchangeRate", //全名
              icon: "i igl-folderOpen",
              componentReq: "exchangeRate",
              id: "H1-3",
              introduce: "introduce.exchangeRate",
              navigation: "exchangeRate",
              assets: "无",
              interval: "home.no",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //贷款
              path: "/",
              label: "Macroscopic.loan",
              icon: "i izhexiantu-xianxing",
              id: "H1-2",
              children: [
                {
                  //私营部门贷款
                  path: "/",
                  label: "menu.loanPsi",
                  fullName: "menu.loanPsi", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "loanPsi",
                  id: "3-7",
                  introduce: "introduce.loanPsi",
                  navigation: "loanPsi",
                  assets: "无",
                  interval: "home.no",
                  type: "L2",
                  authority: "registered", //注册用户
                },
                {
                  //私人债务占GDP比重
                  path: "/",
                  label: "menu.loanGdp",
                  fullName: "menu.loanGdp", //全名
                  icon: "i igl-folderOpen",
                  componentReq: "loanGdp",
                  id: "3-8",
                  introduce: "introduce.loanGdp",
                  navigation: "loanGdp",
                  assets: "无",
                  interval: "home.no",
                  type: "L2",
                  authority: "registered", //注册用户
                },
              ],
            },
          ],
        },
        {
          //债券
          label: "Macroscopic.bond",
          icon: "i izhaiquan-cijizhaiquan",
          nested: "peers", //判断是否多层嵌套multistage
          id: "H2",
          children: [
            {
              //国债收益率
              path: "/",
              label: "menu.USTreasuriesYields",
              fullName: "menu.USTreasuriesYields", //全名
              icon: "i igl-folderOpen",
              componentReq: "USTreasuriesYields",
              id: "H2-1",
              introduce: "introduce.USTreasuriesYields",
              navigation: "USTreasuriesYields",
              assets: "无",
              interval: "home.no",
              type: "L2",
              authority: "registered", //注册用户
            },
          ],
        },
        {
          //股指
          label: "Macroscopic.stockIndex",
          icon: "i imeiguzhibiao",
          nested: "peers", //判断是否多层嵌套multistage
          id: "H3",
          children: [
            {
              //纳斯达克指数
              path: "/",
              label: "menu.macro1",
              fullName: "menu.macro1", //全名
              icon: "i igl-folderOpen",
              componentReq: "NDAQohlc",
              id: "H3-1",
              introduce: "introduce.NDAQohlc",
              navigation: "ndaqOhlc",
              assets: "无",
              interval: "menu.interval3",
              type: "L1",
              authority: "guest", //匿名用户
            },
            {
              //纳斯达克/BTC日K线 改为 纳斯达克指数 vs BTC
              path: "/",
              label: "menu.macro2",
              fullName: "menu.macro2", //全名
              icon: "i igl-folderOpen",
              componentReq: "NDAQBTCPrice",
              id: "H3-2",
              introduce: "introduce.NDAQBTCPrice",
              navigation: "NdaqBtcDayKline",
              assets: "无",
              interval: "menu.interval3",
              type: "L2",
              authority: "registered", //注册用户
            },
          ],
        },
        {
          //GDP

          label: "Macroscopic.GDP",
          icon: "i iGDP2",
          nested: "peers", //判断是否多层嵌套multistage
          id: "H4",
          children: [
            {
              //每周经济指数
              path: "/",
              label: "menu.wei",
              fullName: "menu.wei", //全名
              icon: "i igl-folderOpen",
              componentReq: "wei",
              id: "H4-1",
              introduce: "introduce.wei",
              navigation: "wei",
              assets: "无",
              interval: "home.no",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //GDP
              path: "/",
              label: "menu.GDP",
              fullName: "menu.GDP", //全名
              icon: "i igl-folderOpen",
              componentReq: "GDP",
              id: "H4-2",
              introduce: "introduce.GDP",
              navigation: "GDP",
              assets: "无",
              interval: "home.no",
              type: "L2",
              authority: "registered", //注册用户
            },
          ],
        },
        {
          //资讯

          label: "Macroscopic.info",
          icon: "i izixun",
          nested: "peers", //判断是否多层嵌套multistage
          id: "H5",
          children: [
            {
              //市场快讯 金十数据
              path: "/",
              label: "menu.quickNews",
              fullName: "menu.quickNews", //全名
              icon: "i igl-folderOpen",
              componentReq: "NDAQBTCPrice",
              id: "H5-1",
              introduce: "introduce.quickNews",
              navigation: "quickNews",
              assets: "无",
              interval: "home.no",
              type: "L2",
              authority: "registered", //注册用户
            },
            {
              //财经日历 金十数据
              path: "/",
              label: "menu.economics",
              fullName: "menu.economics", //全名
              icon: "i igl-folderOpen",
              componentReq: "NDAQBTCPrice",
              id: "H5-2",
              introduce: "introduce.quickNews",
              navigation: "economics",
              assets: "无",
              interval: "home.no",
              type: "L2",
              authority: "registered", //注册用户
            },
          ],
        },
      ],
      value: "https://studio.glassnode.com/images/crypto-icons/btc.png",
      options: [
        {
          value: "1",
          label: "Bitcoin (BTC)",
          src: "https://studio.glassnode.com/images/crypto-icons/btc.png",
          req: "",
          radius: "",
        },
        {
          value: "2",
          label: "Ethereum (ETH)",
          src: "https://studio.glassnode.com/images/crypto-icons/eth.png",
          req: "ETF",
          radius: "Holding",
        },
        {
          value: "3",
          label: "Litecoin (LTC)",
          src: "https://studio.glassnode.com/images/crypto-icons/ltc.png",
        },
        {
          value: "4",
          label: "Binance USD (BUSD)",
          src: "https://studio.glassnode.com/images/crypto-icons/busd.png",
        },
        {
          value: "5",
          label: "Gemini dollar (GUSD)",
          src: "https://studio.glassnode.com/images/crypto-icons/gusd.png",
        },
        {
          value: "6",
          label: "HUSD (HUSD)",
          src: "https://studio.glassnode.com/images/crypto-icons/husd.png",
        },
        {
          value: "7",
          label: "HUSD (HUSD)",
          src: "https://studio.glassnode.com/images/crypto-icons/husd.png",
        },
      ],
      langLabel: [
        {
          value: "BTC",
          label: "menu.currencyBTC",
        },
        {
          value: "ETH",
          label: "menu.currencyETH",
        },
        {
          value: "稳定币",
          label: "menu.Stablecoin",
        },
      ],
      imgSrc: "https://studio.glassnode.com/images/crypto-icons/btc.png",
      option: [],
      obj: {},
      radius: "BTC",
      color: [],
      open: "B01-1-4",
      AllAssets:
        "BTC, ETH, LTC, AAVE, ABT, AMPL, ANT, ARMOR, BADGER, BAL, BAND, BAT, BIX, BNT, BOND, BRD, BUSD, BZRX, CELR, CHSB, CND, COMP, CREAM, CRO, CRV, CVC, CVP, DAI, DDX, DENT, DGX, DHT, DMG, DODO, DOUGH, DRGN, ELF, ENG, ENJ, EURS, FET, FTT, FUN, GNO, GUSD, HEGIC, HOT, HPT, HT, HUSD, INDEX, KCS, LAMB, LBA, LDO, LEO, LINK, LOOM, LRC, MANA, MATIC, MCB, MCO, MFT, MIR, MKR, MLN, MTA, MTL, MX, NDX, NEXO, NFTX, NMR, Nsure, OCEAN, OKB, OMG, PAY, PERP, PICKLE, PNK, PNT, POLY, POWR, PPT, QASH, QKC, QNT, RDN, REN, REP, RLC, ROOK, RPL, RSR, SAI, SAN, SNT, SNX, STAKE, STORJ, sUSD, SUSHI, TEL, TOP, UBT, UMA, UNI, USDC, USDK, USDP, USDT, UTK, VERI, WaBi, WAX, WBTC, WETH, wNXM, WTC, YAM, YFI, ZRX",
      token: "",
      navigationName: "",
      moreNoChildren: "",
      moreHasChildren: "",
      oldmenu: [],
      identity1: {
        roleId: 0,
        roleName: "匿名用户",
        roleKey: "guest",
      },
      identity: "",
      authority: "guest",
      authorityList: [
        {
          //匿名用户
          value: "guest",
          label: "login.anonymousUser",
        },
        {
          //注册用户
          value: "registered",
          label: "login.registerUser",
        },
        {
          //付费用户
          value: "advance",
          label: "login.advanceUser",
        },
        {
          //特邀付费用户，公司股东
          value: "vip",
          label: "login.vipUser",
        },
        {
          //超级管理员
          value: "admin",
          label: "login.admin",
        },
        {
          //支持及维护人员, 审核者
          value: "support",
          label: "login.support",
        },
        {
          //审核
          value: "verifier",
          label: "login.verifier",
        },
        {
          //财会人员
          value: "accounting",
          label: "login.accounting",
        },
      ],
      authorityKey: [],
      authorityLabel: "guest",
      nameScroll: false,
      state: "",
      restaurants: [],
      roleKey: "",
      starFraction: 2, //几颗星星
      max: 3,
      starObj: {
        L1: 1,
        L2: 1,
        L3: 2,
        L4: 4,
      },
      DropdownMenu: [
        //新增下拉币种
        {
          //宏观经济指标
          value: 1,
          label: "menu.macroscopic",
        },
      ],
      starsNum: 0,
      lgMaskText:"",

    };
  },
  created() {
    //默认BTC导航存入内存
    localStorage.setItem("oldmenu", JSON.stringify(this.BTCMenu));
    //导航存入内存
    localStorage.setItem("BTCMenu", JSON.stringify(this.BTCMenu));
    localStorage.setItem("ETHmenu", JSON.stringify(this.ETHmenu));
    localStorage.setItem("stableMenu", JSON.stringify(this.stableMenu));
    localStorage.setItem(
      "macroscopicMenu",
      JSON.stringify(this.macroscopicMenu)
    );
 
    // this.$addStorageEvent(1, "radius", "BTC");
    // this.asideMenu=this.BTCMenu
    this.asideMenu = JSON.parse(localStorage.getItem(`oldmenu`));
    //进入页面获取用户等级
    this.identity = JSON.parse(localStorage.getItem("identity"));
    //监听localstorage改变赋值
    window.addEventListener("setItem", (e) => {
      this.identity = JSON.parse(localStorage.getItem("identity"));
    });

    if (this.$i18n.locale == "en") {
      //英语处理单词首字母大写
      this.handelMenuCapital(this.asideMenu);
    }

    //首次登录没有内存 默认导航第一项
    let Component = localStorage.getItem(`currentTabComponent`);

    if (Component == null || Component == undefined) {
      let menu = JSON.parse(localStorage.getItem(`oldmenu`));

      this.$addStorageEvent(1, "open", menu[0].children[0].children[0].id);
      this.$addStorageEvent(1, "show", "component");
      this.$addStorageEvent(
        1,
        "params",
        JSON.stringify(menu[0].children[0].children[0])
      );
      this.$addStorageEvent(1, "currency", false);
      this.$addStorageEvent(
        1,
        "assets",
        menu[0].children[0].children[0].assets
      );
      this.$addStorageEvent(
        1,
        "currentTabComponent",
        menu[0].children[0].children[0].navigation
      ); //组件名称
      this.$addStorageEvent(
        1,
        "navName",
        JSON.stringify(menu[0].children[0].children[0].fullName)
      ); //导航名称
    }
  },

  mounted() {
    this.token = localStorage.token;


//     const menuItems = document.querySelectorAll('.el-menu-item');

// menuItems.forEach(function(menuItem) {
//   const scrollingText = menuItem.querySelector('.scrolling-text');

//   menuItem.addEventListener('mouseenter', function() {
//     if (scrollingText.scrollWidth > scrollingText.clientWidth) {
//       window.getComputedStyle(scrollingText).animationPlayState = 'running';
//     }
//   });

//   menuItem.addEventListener('mouseleave', function() {
//     window.getComputedStyle(scrollingText).animationPlayState = 'paused';
//   });
// });


const scrollingTextBoxes = document.querySelectorAll('.scrolling-textBox');

scrollingTextBoxes.forEach(function(scrollingTextBox) {
  const scrollingText = scrollingTextBox.querySelector('.scrolling-text');
  const textWidth = scrollingText.offsetWidth;
  const containerWidth = scrollingTextBox.offsetWidth;

  if (textWidth > containerWidth) {
    scrollingText.style.animation = `marquee ${(textWidth / 50)}s linear infinite`;
  }
});



    if (this.$router.path == "/") {
      localStorage.setItem("permissionMask", JSON.stringify(false));
    }
    this.$addStorageEvent(
      1,
      "radiusSrc",
      JSON.stringify(`https://studio.glassnode.com/images/crypto-icons/btc.png`)
    );
    this.roleKey = JSON.parse(localStorage.getItem("identity")).roleKey;
    this.$addStorageEvent(1, "asideMenu", JSON.stringify(this.asideMenu));
    //处理下拉框数据
    this.handelSelect();
    this.radius = localStorage.getItem("radius");
    this.open = localStorage.getItem("open");
    this.lgMask = JSON.parse(localStorage.getItem("permissionMask"));
    this.UpdateState=localStorage.getItem("UpdateState")
   
    //监听localstorage改变赋值
    window.addEventListener("setItem", () => {
      this.UpdateState=localStorage.getItem("UpdateState")
      this.token = localStorage.token;
      this.identity = JSON.parse(localStorage.getItem("identity"));
      this.roleKey = JSON.parse(localStorage.getItem("identity")).roleKey;
      this.lgMask = JSON.parse(localStorage.getItem("permissionMask"));
      this.authority = JSON.parse(localStorage.getItem("authority"));
      this.open = localStorage.getItem("open");
      this.value = JSON.parse(localStorage.getItem("radiusSrc"));
      this.radius = localStorage.getItem("radius");
      this.imgSrc = JSON.parse(localStorage.getItem("radiusSrc"));
    });

    if (Array.isArray(this.authority)) {
      this.authority.forEach((item1) => {
        this.authorityKey.push(
          this.authorityList.find((item) => item.value == item1).label
        );
      });
    } else {
      this.authorityLabel = this.authorityList.find(
        (item) => item.value == this.authority
      ).label;
    }

    this.restaurants = this.handelMenu(this.handelAllMenu(this.asideMenu));
    
  },
  watch: {
    UpdateState:{
      handler(val) {
        // console.log(!val,val,"及附加覅");
        if (val) {
          this.$addStorageEvent(1, "open", "");
          this.open=""
        }
    
      }, 
          
     
    },
    //监听币种改变左侧导航
    radius: {
      handler(val) {
        let obj = {};
        switch (val) {
          case "BTC":
            if (this.$i18n.locale == "zh") {
              localStorage.setItem("oldmenu", JSON.stringify(this.BTCMenu));
            }

            this.asideMenu = JSON.parse(JSON.stringify(this.BTCMenu));
           

            this.BTCisActive = true;
            this.ETHisActive = false;
            this.WisActive = false;
            this.macroscopicActive= false;

            break;
          case "ETH":
            localStorage.setItem("oldmenu", JSON.stringify(this.ETHmenu));
            this.asideMenu = JSON.parse(JSON.stringify(this.ETHmenu));

      

            this.BTCisActive = false;
            this.ETHisActive = true;
            this.WisActive = false;
            this.macroscopicActive= false;

            break;

          case "稳定币":
            localStorage.setItem("oldmenu", JSON.stringify(this.stableMenu));
            this.asideMenu = JSON.parse(JSON.stringify(this.stableMenu));
        
            this.WisActive = true;
            this.BTCisActive = false;
            this.ETHisActive = false;
            this.macroscopicActive= false;
            break;
          // 宏观经济指标
          case "menu.macroscopic":
            localStorage.setItem(
              "oldmenu",
              JSON.stringify(this.macroscopicMenu)
            );
            this.asideMenu = JSON.parse(JSON.stringify(this.macroscopicMenu));
            this.BTCisActive = false;
            this.ETHisActive = false;
            this.WisActive = false;
            this.macroscopicActive= true;
            

            break;

          default:
        
            break;
        }

        if (this.$i18n.locale !== "en") {
          //中文未处理的导航存入内存
          localStorage.setItem("oldmenu", JSON.stringify(this.asideMenu));
        } else {
          //英文状态下切换币种直接处理成英文
          this.asideMenu = this.handelMenuCapital(
            JSON.parse(JSON.stringify(this.asideMenu))
          );
        }
      },
      immediate: true,
    },
    token: {
      handler(val) {
        if (!val) {
          localStorage.setItem("identity", JSON.stringify({})); //没有token就是匿名用户
          this.lgMaskText = "login.btn"
          return;
        }else{
          this.lgMaskText = "login.upgrade"
        }

      },
    },
     //页面浏览权限控制
    // roleKey: {
    //   handler(val) {
       
    //     switch (this.identity.roleId) {
    //       case undefined: //匿名用户
    //         if (this.authority !== "guest") {
    //           this.lgMaskText = `login.btn`
    //           this.lgMask = true;
    //           this.$addStorageEvent(1, "permissionMask", JSON.stringify(true));
    //         } else {
    //           this.lgMask = false;
    //           this.$addStorageEvent(1, "permissionMask", JSON.stringify(false));
    //         }
    //         break;
    //       case 2: //注册用户可以查看 注册 匿名页面
    //         if (this.authority !== "guest" && this.authority !== "registered") {
    //           this.lgMask = true;
    //           this.$addStorageEvent(1, "permissionMask", JSON.stringify(true));
    //         } else {
    //           this.lgMask = false;
    //           this.$addStorageEvent(1, "permissionMask", JSON.stringify(false));
    //         }
    //         break;
    //       case 3: //付费用户可以查看 付费 注册 匿名页面
    //         if (
    //           this.authority !== "guest" &&
    //           this.authority !== "registered" &&
    //           this.authority !== "advance"
    //         ) {
    //           this.lgMask = true;
    //           this.$addStorageEvent(1, "permissionMask", JSON.stringify(true));
    //         } else {
    //           this.lgMask = false;
    //           this.$addStorageEvent(1, "permissionMask", JSON.stringify(false));
    //         }
    //         break;
    //       case 4: //特邀付费用户可以查看 付费 注册 匿名页面 基础页面都可以看
    //         break;
    //       case 7: //财会人员可以查看 注册 匿名页面
    //         if (this.authority !== "guest" && this.authority !== "registered") {
    //           this.lgMask = true;
    //           this.$addStorageEvent(1, "permissionMask", JSON.stringify(true));
    //         } else {
    //           this.lgMask = false;
    //           this.$addStorageEvent(1, "permissionMask", JSON.stringify(false));
    //         }
    //         break;

    //       default:
    //         this.lgMask = false;
    //         this.$addStorageEvent(1, "permissionMask", JSON.stringify(false));
    //         break;
    //     }
    //   },
    //   deep: true,
    // },
   
    // 监听语言切换
    "$i18n.locale"(newValue) {
      //币种是BTC时 检查是否是英文大写字母导航  如果是就要存入有翻译的原始导航 不然无法进行语言切换
      if (
        this.radius == "BTC" &&
        (this.radius,
        JSON.parse(
          localStorage.getItem("oldmenu")[0].label !== bTCMenu[0].label
        ))
      ) {
        this.asideMenu = bTCMenu;
      } else {
        if (newValue == "en") {
          this.$nextTick(() => {
            this.asideMenu = this.handelMenuCapital(this.asideMenu);
          });
        } else {
          this.asideMenu = JSON.parse(localStorage.getItem("oldmenu"));
        }
      }

      this.restaurants = this.handelMenu(this.handelAllMenu(this.asideMenu));
    },

    //监听点击导航名称变化存入缓存
    navigationName(val) {
      if (!val.navigation) return;
      this.$addStorageEvent(1, "currentTabComponent", val.navigation);
    },
  },
  methods: {

    handelUpdateContent(){
      this.UpdateState = true
      this.$addStorageEvent(1, "currentTabComponent",`UpdateContent`);
      this.$addStorageEvent(1, "UpdateState",true);
    },
    //下拉选择币种
    handelChang(val) {
      this.UpdateState = false
      this.$addStorageEvent(1, "UpdateState", "");
      //处理下拉框数据
      this.handelSelect();
      let obj = {};
      // this.open = "";
      obj = this.option.find((item) => {
        return item.label === val; //筛选出匹配数据
      });

      this.starsNum = 0;
      //高亮选中币种

      switch (val) {
        case "BTC":
          this.BTCisActive = true;
          this.ETHisActive = false;
          this.WisActive = false;

          break;
        case "ETH":
          this.BTCisActive = false;
          this.ETHisActive = true;
          this.WisActive = false;
          break;
          break;
        case "稳定币":
          this.WisActive = true;
          this.BTCisActive = false;
          this.ETHisActive = false;
          break;

        default:
          this.WisActive = false;
          this.BTCisActive = false;
          this.ETHisActive = false;

          break;
      }

      this.$addStorageEvent(1, "radiusSrc", JSON.stringify(obj.src));

      //存入选择币种到locastorage
      this.radius = obj.label;
      this.$addStorageEvent(1, "radius", this.radius);
      this.imgSrc = obj.src;
      //不同币种 对应默认显示不同默认导航
      switch (obj.label) {
        case "BTC":
          if (this.$i18n.locale == `zh`) {
            localStorage.setItem("oldmenu", JSON.stringify(this.BTCMenu));
          }

          this.asideMenu = JSON.parse(JSON.stringify(this.BTCMenu));
          this.open = "B01-1-4";
          obj = {
            //地址统计
            path: "/",
            label: "menu.onchain2",
            fullName: "menu.onchain2",
            icon: "i igl-folderOpen",
            componentReq: "newAddress2",
            radius: "btc",
            id: "B01-1-4",
            introduce: "introduce.address",
            navigation: "newAddress",
            assets: "BTC、ETH",
            interval: "menu.interval3",
            type: "L1",
            authority: "guest", //匿名用户
          };
          this.$addStorageEvent(1, "open", this.open);
          this.$addStorageEvent(1, "show", "component");
          this.$addStorageEvent(1, "params", JSON.stringify(obj));
          this.$addStorageEvent(1, "introduce", obj.introduce);
          this.$addStorageEvent(1, "interval", obj.interval);
          this.$addStorageEvent(1, "currentTabComponent", obj.navigation);
          this.$addStorageEvent(1, "currency", false);
          this.$addStorageEvent(1, "assets", obj.assets);
          this.$store.commit("selectMenu", obj);
          this.$addStorageEvent(1, "navName", JSON.stringify(obj.fullName));
          // this.$addStorageEvent(1, "asideMenu", JSON.stringify(this.asideMenu));

          break;
        case "ETH":
          localStorage.setItem("oldmenu", JSON.stringify(this.ETHmenu));
          this.asideMenu = JSON.parse(JSON.stringify(this.ETHmenu));

          (obj = {
            //地址统计
            path: "/",
            label: "menu.onchain2",
            fullName: "menu.onchain2",
            icon: "i igl-folderOpen",
            componentReq: "address",
            radius: "eth",
            id: "E01-1-1",
            introduce: "introduce.ethAddress",
            navigation: "ethAddress",
            assets: "BTC、ETH",
            interval: "menu.interval3",
            type: "L1",
            authority: "guest", //匿名用户
          }),
            this.$addStorageEvent(1, "show", "component");
          this.$addStorageEvent(1, "params", JSON.stringify(obj));
          this.$addStorageEvent(1, "currentTabComponent", obj.navigation);
          this.$addStorageEvent(1, "currency", false);
          this.$addStorageEvent(1, "assets", obj.assets);
          this.$store.commit("selectMenu", obj);
          this.$addStorageEvent(1, "introduce", obj.introduce);
          this.$addStorageEvent(1, "interval", obj.interval);
          this.$addStorageEvent(1, "navName", JSON.stringify(obj.fullName));

          this.open = "E01-1-1";
          this.$addStorageEvent(1, "open", this.open);
          //  this.$addStorageEvent(1, "asideMenu", JSON.stringify(this.asideMenu));

          break;
        case "稳定币":
          localStorage.setItem("oldmenu", JSON.stringify(this.stableMenu));
          this.asideMenu = JSON.parse(JSON.stringify(this.stableMenu));
          this.open = "w1-1";
          obj = {
            //总流通量
            path: "/",
            label: "menu2.cstotal",
            fullName: "menu2.cstotal",
            icon: "i igl-folderOpen",
            componentReq: "",
            radius: "eth",
            id: "w1-1",
            introduce: "introduce.none", //无介绍
            navigation: "circulationTotalCSupply",
            assets: "USDC、USDT、BUSD",
            interval: "menu.interval3", //历史数据
            type: "L1",
            authority: "guest", //匿名用户
          };

          this.$addStorageEvent(1, "show", "component");
          this.$addStorageEvent(1, "params", JSON.stringify(obj));
          // this.$addStorageEvent(1, "assets", "BTC、ETH、LTC");
          this.$addStorageEvent(1, "currentTabComponent", obj.navigation);
          this.$addStorageEvent(1, "assets", obj.assets);
          this.$addStorageEvent(1, "currency", false);
          this.$store.commit("selectMenu", obj);
          this.$addStorageEvent(1, "introduce", obj.introduce);
          this.$addStorageEvent(1, "interval", obj.interval);
          this.$addStorageEvent(1, "open", obj.id);
          // this.$addStorageEvent(1, "asideMenu", JSON.stringify(this.asideMenu));
          this.$addStorageEvent(1, "navName", JSON.stringify(obj.fullName));
          break;
        // 宏观经济指标
        case "menu.macroscopic":
          localStorage.setItem("oldmenu", JSON.stringify(this.macroscopicMenu));
          this.asideMenu = JSON.parse(JSON.stringify(this.macroscopicMenu));
          this.open = "H1-1";
          obj = {
            //货币供应量
            path: "/",
            label: "menu.MoneyStockMeasures",
            fullName: "menu.MoneyStockMeasures", //全名
            icon: "i igl-folderOpen",
            componentReq: "MoneyStockMeasures",
            id: "H1-1",
            introduce: "introduce.MoneyStockMeasures",
            navigation: "MoneyStockMeasures",
            assets: "无",
            interval: "home.no",
            type: "L2",
            authority: "registered", //注册用户
          };

          this.$addStorageEvent(1, "show", "component");
          this.$addStorageEvent(1, "params", JSON.stringify(obj));
          // this.$addStorageEvent(1, "assets", "BTC、ETH、LTC");
          this.$addStorageEvent(1, "currentTabComponent", obj.navigation);
          this.$addStorageEvent(1, "assets", obj.assets);
          this.$addStorageEvent(1, "currency", false);
          this.$store.commit("selectMenu", obj);
          this.$addStorageEvent(1, "introduce", obj.introduce);
          this.$addStorageEvent(1, "interval", obj.interval);
          this.$addStorageEvent(1, "open", obj.id);
          // this.$addStorageEvent(1, "asideMenu", JSON.stringify(this.asideMenu));
          this.$addStorageEvent(1, "navName", JSON.stringify(obj.fullName));
          break;

        default:
          Message({
            message: "待开发",
            type: "warning",
            customClass: "messageClass",
          });

          return;
          this.asideMenu = [];
          obj = {};
          //判断ALLmenu的时候 默认请求改变
          this.$addStorageEvent(1, "params", JSON.stringify(obj));
          this.$store.commit("selectMenu", obj);
          break;
      }
      //切换币种清空sma
      this.$addStorageEvent(1, "sma", "");

      //判断不同币种 价格按钮展示BTC /ETH
      if (this.radius == "BTC") {
        this.$addStorageEvent(1, "ethFlag", JSON.stringify(false));
        this.$addStorageEvent(1, "btcFlag", JSON.stringify(true));
      } else if (this.radius == "ETH") {
        this.$addStorageEvent(1, "ethFlag", JSON.stringify(true));
        this.$addStorageEvent(1, "btcFlag", JSON.stringify(false));
      }

      this.$addStorageEvent(1, "imgsrc", JSON.stringify(val));

      this.$addStorageEvent(1, "src", JSON.stringify(obj));
      //搜索导航栏赋值
      this.restaurants = this.handelMenu(this.handelAllMenu(this.asideMenu));
      //切换币种 权限遮罩验证
      let navItem = JSON.parse(localStorage.getItem("params"));

      //当前账号权限
      this.identity = JSON.parse(localStorage.getItem("identity"));
      //页面浏览权限控制
      // switch (this.identity.roleId) {
      //   case undefined: //匿名用户
      //     if (navItem.authority !== "guest") {
      //       this.$addStorageEvent(1, "permissionMask", JSON.stringify(true));
      //     } else {
      //       this.$addStorageEvent(1, "permissionMask", JSON.stringify(false));
      //     }
      //     break;
      //   case 2: //注册用户可以查看 注册 匿名页面
      //     if (
      //       navItem.authority !== "guest" &&
      //       navItem.authority !== "registered"
      //     ) {
      //       this.$addStorageEvent(1, "permissionMask", JSON.stringify(true));
      //       return;
      //     } else {
      //       this.$addStorageEvent(1, "permissionMask", JSON.stringify(false));
      //     }
      //     break;
      //   case 3: //付费用户可以查看 付费 注册 匿名页面
      //     if (
      //       navItem.authority !== "guest" &&
      //       navItem.authority !== "registered" &&
      //       navItem.authority !== "advance"
      //     ) {
      //       this.$addStorageEvent(1, "permissionMask", JSON.stringify(true));
      //     } else {
      //       this.$addStorageEvent(1, "permissionMask", JSON.stringify(false));
      //     }
      //     break;
      //   case 4: //特邀付费用户可以查看 付费 注册 匿名页面 基础页面都可以看
      //     break;
      //   case 7: //财会人员可以查看 注册 匿名页面
      //     if (
      //       navItem.authority !== "guest" &&
      //       navItem.authority !== "registered"
      //     ) {
      //       this.$addStorageEvent(1, "permissionMask", JSON.stringify(true));
      //     } else {
      //       this.$addStorageEvent(1, "permissionMask", JSON.stringify(false));
      //     }
      //     break;

      //   default:
      //     this.$addStorageEvent(1, "permissionMask", JSON.stringify(false));
      //     break;
      // }
    },
    //点击侧边导航栏传参
    handelClick(label) {
      this.UpdateState = false
      this.$addStorageEvent(1, "UpdateState", "");
      if (!label.id) return;
      this.$addStorageEvent(1, "lengthFlag", this.UpdateState);
      //每点击一次导航栏 页面超时提醒重新计算
      this.$addStorageEvent(1, "overtime", "");
      //获取点击页面所需要权限
      this.authority = label.authority;

      this.$addStorageEvent(1, "authority", JSON.stringify(label.authority));
      this.identity = JSON.parse(localStorage.getItem("identity"));

      //页面浏览权限控制
      // switch (this.identity.roleId) {
      //   case undefined: //匿名用户
      //     if (label.authority !== "guest") {
      //       this.lgMask = true;
      //       this.lgMaskText = `login.btn`
      //       this.$addStorageEvent(1, "permissionMask", JSON.stringify(true));
      //     } else {
      //       this.lgMask = false;
      //       this.$addStorageEvent(1, "permissionMask", JSON.stringify(false));
      //     }
      //     break;
      //   case 2: //注册用户可以查看 注册 匿名页面
      //     if (label.authority !== "guest" && label.authority !== "registered") {
      //       this.lgMask = true;
      //       this.$addStorageEvent(1, "permissionMask", JSON.stringify(true));
      //     } else {
      //       this.lgMask = false;
      //       this.$addStorageEvent(1, "permissionMask", JSON.stringify(false));
      //     }
      //     break;
      //   case 3: //付费用户可以查看 付费 注册 匿名页面
      //     if (
      //       label.authority !== "guest" &&
      //       label.authority !== "registered" &&
      //       label.authority !== "advance"
      //     ) {
      //       this.lgMask = true;
      //       this.$addStorageEvent(1, "permissionMask", JSON.stringify(true));
      //     } else {
      //       this.lgMask = false;
      //       this.$addStorageEvent(1, "permissionMask", JSON.stringify(false));
      //     }
      //     break;
      //   case 4: //特邀付费用户可以查看 付费 注册 匿名页面 基础页面都可以看
      //     break;
      //   case 7: //财会人员可以查看 注册 匿名页面
      //     if (label.authority !== "guest" && label.authority !== "registered") {
      //       this.lgMask = true;
      //       this.$addStorageEvent(1, "permissionMask", JSON.stringify(true));
      //     } else {
      //       this.lgMask = false;
      //       this.$addStorageEvent(1, "permissionMask", JSON.stringify(false));
      //     }
      //     break;

      //   default:
      //     this.lgMask = false;
      //     this.$addStorageEvent(1, "permissionMask", JSON.stringify(false));
      //     break;
      // }
      this.open = label.id;
      this.$addStorageEvent(1, "open", label.id); //高亮导航栏

      let params = JSON.stringify(label);
      //跳转到其他页面的时候点击导航  就回到home页
      if (this.$route.path !== "/") {
        this.$router.push({
          path: "/",
          query: { res: params },
        });
      }

      //点击导航栏就关闭遮罩
      this.$addStorageEvent(1, "maskShow", false);
      // 点击导航就清空移动平均线里面的值
      this.$addStorageEvent(1, "sma", "");
      //每换一个页面时间清空
      this.$addStorageEvent(1, "chooseTime", JSON.stringify(""));
      //存入每个页面在导航显示的名称
      this.$addStorageEvent(1, "navName", JSON.stringify(label.fullName));

      //拿到点击侧边导航名称
      this.navigationName = label;
      //点击导航存接口介绍
      this.$addStorageEvent(1, "introduce", label.introduce);
      this.$addStorageEvent(1, "interval", label.interval);
      if (label.assets) {
        this.$addStorageEvent(1, "assets", label.assets);
      }
      //根据导航名对应不同的币种范围显示
      switch (label.req) {
        case "transrate":
        case "transactions":
        case "market":
          this.$addStorageEvent(1, "Assets", this.ltcAssets);
          break;
        case "transsziemean":
        case "tanssizetotal":
        case "arh99":
        case "arh99day":
          this.$addStorageEvent(1, "Assets", this.BTCAssets);
          break;
        case "derivatives":
        case "distribution":
        case "jzr60":
        case "jzr60day":
        case "ethbigtxcount":
          this.$addStorageEvent(1, "Assets", this.ethAssets);
          break;
        case "ETF":
          let Assets = "Holding, Flows";
          this.$addStorageEvent(1, "Assets", Assets);
          break;
        case "NDAQ":
        case "NDAQ":
          this.$addStorageEvent(1, "Assets", "Nasdaq Data");
          break;
        default:
          //除开以上页面其他页面未自带币种范围的都使用所有范围
          if (!label.assets) {
            this.$addStorageEvent(1, "Assets", this.AllAssets);
          }

          break;
      }
      //存数据到VUX
      this.$store.commit("selectMenu", label);

      // 跳转页面传参
      if (label.componentReq) {
        //显示到动态组件
        // this.$router.push({
        //   path: "/Home",
        //   query: { res: params },
        // });
        this.$addStorageEvent(1, "show", "component");
        this.$addStorageEvent(1, "currentTabComponent", label.navigation);
        this.$addStorageEvent(1, "params", params);
      } else {
        if (label.label == "menu.exchange1") {
          this.$router.push({
            path: "/Bian",
          });
        } else {
          //显示到HOME页图表
          this.$router.push({
            path: "/",
            query: { res: params },
          });

          this.$addStorageEvent(1, "show", true);
          this.$addStorageEvent(1, "params", params);
        }
      }

      //日期时间选择框的禁用启用
      switch (label.navigation) {
        case "arh99day":
        case "jzr60day":
        case "BTCUSDT":
        case "holder":
        case "holderBalance":
        case "getBuyData":
        case "getBuyAmountData":
        case "getDiffData":
        case "getDiffAmountData":
        case "getProfitData":
        case "getProfitAmountData":
        case "getTopList":
        case "derivatives":
        case "getTopListWatch":
        case "btcTags":
        case "ethTopAddrList":
        case "ma730day":
        case "":
        case "priceValue":
        case "":
        case "getDayBalanceData":
        case "getDayBalanceAmountData":
        case "economics":
        case "quickNews":
        case "buyData":
        case "diffData":
        case "profitData":
        case "balanceData":
        case "coinmarketall":
        case "":
        case "":
        case "":
          //日期选择框禁用
          this.$addStorageEvent(1, "timeDisable", true);
          this.$addStorageEvent(1, "timeShow", false);
          break;

        default:
          this.$addStorageEvent(1, "timeShow", true);
          this.$addStorageEvent(1, "timeDisable", false);
          break;
      }
      //btc ETC按钮显示隐藏
      switch (
        label.req //组件按钮禁用在HOME页面
      ) {
        case "derivatives":
        case "jzr60":
        case "jzr60day":
        case "":
        case "":
        case "":
        case "":
        case "":
        case "":
        case "":
          //按钮禁用
          this.$addStorageEvent(1, "buttonShow", false);
          break;

        default:
          this.$addStorageEvent(1, "buttonShow", true);
          break;
      }
    },
    //侧边导航搜索框币种显示
    handelSelect() {
      // let menuStr =
      //   "BTC, ETH, LTC, AAVE, ABT, AMPL, ANT, ARMOR, BADGER, BAL, BAND, BAT, BIX, BNT, BOND, BRD, BUSD, BZRX, CELR, CHSB, CND, COMP, CREAM, CRO, CRV, CVC, CVP, DAI, DDX, DENT, DGX, DHT, DMG, DODO, DOUGH, DRGN, ELF, ENG, ENJ, EURS, FET, FTT, FUN, GNO, GUSD, HEGIC, HOT, HPT, HT, HUSD, INDEX, KCS, LAMB, LBA, LDO, LEO, LINK, LOOM, LRC, MANA, MATIC, MCB, MCO, MFT, MIR, MKR, MLN, MTA, MTL, MX, NDX, NEXO, NFTX, NMR, Nsure, OCEAN, OKB, OMG, PAY, PERP, PICKLE, PNK, PNT, POLY, POWR, PPT, QASH, QKC, QNT, RDN, REN, REP, RLC, ROOK, RPL, RSR, SAI, SAN, SNT, SNX, STAKE, STORJ, sUSD, SUSHI, TEL, TOP, UBT, UMA, UNI, USDC, USDK, USDP, USDT, UTK, VERI, WaBi, WAX, WBTC, WETH, wNXM, WTC, YAM, YFI, ZRX";
      //当前只展示BTC ETH和稳定币
      let menuStr = "BTC, ETH,稳定币,menu.macroscopic";
      menuStr = menuStr.split(",");
      // let lineStyleColor = `#f7931a,#627eea,#bfbbbb,#2ebac6,#65ffff,#000000,#52dbe7,#1890ff,#f2b044,#232323,#516aff,#ff5000,#000000,#000d2b,#ff4438,#fe5d86,#f0b90b,#003cda,#000000,#01c38d,#383939,#00d395,#69e2dc,#103f68,#40649f,#3ab03e,#202fe3,#f6c559,#422d8c,#666666,#e4c893,#0066cd,#437cc5,#437cc5,#fff706,#aa08c4,#c91111,#2b5ebb,#2f2f2f,#624dbf,#2468e4,#202944`;
      // lineStyleColor = lineStyleColor.split(",");
      menuStr.map((item, index) => {
        let obJ = {};
        obJ.value = index;
        obJ.label = item.trim();
        obJ.color = `#${Math.round(Math.random() * 9)}${Math.round(
          Math.random() * 9
        )}${Math.round(Math.random() * 9)}${Math.round(
          Math.random() * 9
        )}${Math.round(Math.random() * 9)}${Math.round(Math.random() * 9)}`;
        let eachItem = item.trim();
        if (eachItem == "MX") {
          obJ.src = `https://studio.glassnode.com/images/crypto-icons/generic.png`;
        } else {
          obJ.src = `https://studio.glassnode.com/images/crypto-icons/${eachItem.toLowerCase()}.png`;
        }

        this.option.push(obJ);
      });
    },
    //币种中英文翻译
    handelCurrency(label) {
      return this.langLabel.find((item) => item.value == label).label;
    },
    //将导航名每个单词首字母大写
    handelMenuCapital(menu, lang) {
      let mewMenu = [...menu];
      mewMenu.some((item) => {
        let newLabel = this.$t(item.label).split(" ");
        item.label = this.handelCapital(newLabel);
        item.children.some((subItem) => {
          let newSubLabel = this.$t(subItem.label).split(" ");
          subItem.label = this.handelCapital(newSubLabel);
          if (subItem.children) {
            subItem.children.some((sunItem) => {
              let newSunLabel = this.$t(sunItem.label).split(" ");
              sunItem.label = this.handelCapital(newSunLabel);
            });
          }
        });
      });

      return mewMenu;
    },
    handelCapital(arr) {
      for (var i = 0; i < arr.length; i++) {
        //将首字母大写 拼接后面没有首字母的部分
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
      }

      return arr.join(` `);
    },
    //拿到角色等级的roleKey 显示对应等级
    handelAuthority(data) {
      let key = data;
      if (!key) {
        key = "guest";
      }
      return this.authorityList.find((item) => item.value == key).label;
    },
    //点击遮罩的升级账户
    handelUpgradeAccount() {
        let flag = false
        this.$addStorageEvent(1, "dialogLoginVisible",JSON.stringify(flag) );
      if(this.lgMaskText && this.lgMaskText== "login.btn"){
        flag=true
        
        this.$addStorageEvent(1, "dialogLoginVisible", JSON.stringify(flag));
      } else if (this.lgMask  && this.$route.path == "/AccountUpgrade") {
        //遮罩为true
        this.$router.go(0); //本页面弹出遮罩  点击遮罩的升级刷新一次
      } else if(this.lgMaskText && this.lgMaskText== "login.upgrade"){
        let level = JSON.parse(localStorage.getItem("identity")).level;
        if (!level) {
          //匿名用户不能跳转升级
          this.$message({
            message: this.$t(`login.loginUpgrade`),
            type: "error",
            customClass: "messageClass",
          });
          return;
        } else {
          this.$router.push(`/AccountUpgrade`);
        }
      }


      
    },
    //搜素框默认显示的内容
    querySearchAsync(queryString, cb) {
      this.restaurants = this.handelMenu(this.handelAllMenu(this.asideMenu));
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    //查找有关键字的项目
    createStateFilter(queryString) {
      return (state) => {
        return state.value.toLowerCase().includes(queryString.toLowerCase());
      };
    },
    //选中导航搜索结果中的某一项
    handleSelect(item) {
      console.log(item, 44);
      let newObj = item;
      let oldmenu = JSON.parse(localStorage.getItem("oldmenu"));
      switch (item.address) {
        case "S-1": //三颗星 L4
          this.asideMenu = this.filterData(
            oldmenu,
            (item) => item.type == `L4`
          );
          this.starsNum = 3;
          return;
          break;
        case "S-2": //2颗星 L3
          this.asideMenu = this.filterData(
            oldmenu,
            (item) => item.type == `L3`
          );
          this.starsNum = 2;
          return;
          break;
        case "S-3": //1颗星 L1 L2
          this.asideMenu = this.filterData(
            oldmenu,
            (item) => item.type == `L1` || item.type == `L2`
          );
          this.starsNum = 1;
          return;
          break;

        default:
          break;
      }
      // if (item.address== "S-2" ||item.address== "S-1"|| item.address== "S-3") {

      //   return
      // }

      if (!item.label) {
        //点击了搜索图标
        newObj = this.restaurants.find((item) => item.value == this.state);
      }
      if (this.$route.path !== "/") {
        this.$router.push({
          path: "/",
          // query: { res: params },
        });
      }
      this.$addStorageEvent(1, "show", "component");
      this.$addStorageEvent(1, "params", JSON.stringify(newObj));
      this.$addStorageEvent(1, "currentTabComponent", newObj.navigation); //组件名称 、open、币种
      // this.$addStorageEvent(1, "params", JSON.stringify(params));
      this.$addStorageEvent(1, "open", newObj.id);
      this.$addStorageEvent(1, "introduce", newObj.introduce);
      this.$addStorageEvent(1, "interval", newObj.interval);
      //存入每个页面在导航显示的名称
      this.$addStorageEvent(1, "navName", JSON.stringify(newObj.fullName));
      this.state = "";
    },

    //扁平化导航数组
    handelMenu(data, label) {
      let subMenu = data;
      subMenu.forEach((newitem) => {
        newitem.value = this.$t(newitem.label);
        newitem.address = newitem.id;
      });
      for (let i = 1; i < 4; i++) {
        subMenu.unshift({
          value: "",
          address: `S-${i}`,
        });
      }
      return subMenu;
    },
    //扁平化导航数组 递归
    handelAllMenu(arr) {
      var result = [];
      arr.forEach((item) => {
        if (!item.children) {
          result.push(item);
        } else {
          var nestedItems = this.handelAllMenu(item.children);
          result = result.concat(nestedItems);
        }
      });

      return result;
    },

    handelItem(value) {},
    //过滤导航
    filterData(data, condition) {
      return data.reduce((acc, item) => {
        const newItem = { ...item };
        if (item.children && item.children.length > 0) {
          newItem.children = this.filterData(item.children, condition);
        }
        if (
          condition(newItem) ||
          (newItem.children && newItem.children.length > 0)
        ) {
          acc.push(newItem);
        }
        return acc;
      }, []);
    },
    //清除星星筛选
    handelIconClose() {
      this.starsNum = 0;
      this.asideMenu = JSON.parse(localStorage.getItem("oldmenu"));
    },
  },
};
</script>

<style  lang="scss" scoped>
.updateBoxActive{
  color: #40b6ff;
  text-align: left;
  // padding: 10px 20px;
  font-size: 14px;
  padding-left: 20px;
  font-weight: 600;
}
.updateBox {
  display: flex;
  align-items: center;
  padding-left: 20px;
  cursor: pointer;
  // outline: 1px solid red;
  margin-top: 5px;
}
.updateBox:hover {
  transition: opacity 0.2s ease-in-out;
  background: #ecf5ff;
}
.update {
  // outline: 1px solid red;
  text-align: left;
  // padding: 10px 20px;
  font-size: 14px;
  padding-left: 20px;
  font-weight: 600;
  color: #000;
}
//导航展开收起
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 320px;
  min-height: 100px;
}

//下拉币种
.drop-down {
  // outline: 1px solid red;
  // width: 20px;
  // margin-left: 10px;

  // position: fixed;
  // top: 80px;
  z-index: 99999;
  // left: 290px;
  font-weight: 500;
  color: #000;
  .el-dropdown-link:hover {
    .el-icon-arrow-down {
      color: #f7931a;
      font-weight: 600;
    }
  }
}
.other{
  padding-right:5px;
}

.el-dropdown-menu {
  background: rgba(0, 0, 0, 0.7);
}
.el-dropdown-item:hover {
  color: red;
  background: gold;
}
// .el-menu-vertical-demo .el-submenu.is-active .el-menu-item {
//   pointer-events: none;
// }

.side {
  // background-image: linear-gradient(to bottom, rgba(231,248,255, 0.6), rgba(231,248,255, 0.6),rgba(231,248,255, 0.2), rgba(255,255,255,0));
  // background-image: linear-gradient(
  //   to bottom,
  //   rgba(231, 248, 255, 1),
  //   rgba(231, 248, 255, 1),
  //   rgba(231, 248, 255, 0.9),
  //   rgba(255, 255, 255, 0)
  // ) ;
  // background: red;

  background: rgba(231, 248, 255, 1);

  position: relative;
  box-sizing: border-box;
  padding-right: 20px;

  .currency:after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -1px;
    width: 325px;
    height: 0px;
    // box-shadow: 0px 2px 5px 1px #888888; /* 仅在下部添加阴影效果 */
    box-shadow: 0 2px 5px 1px #888;
  }

  padding-top: 120px;
  //币种切换
  .currency {
    width: 350px;
    height: 60px;

    // outline: 1px solid red;
    position: fixed;
    top: 60px;
    z-index: 999;

    background-image: linear-gradient(
      to bottom,
      rgba(231, 248, 255, 1),
      rgba(231, 248, 255, 1),
      rgba(231, 248, 255, 1),
      #fff
    );

    // background: red;

    // box-shadow: 0px 5px 8px -5px #888888;

    .currencySwitching {
      // outline: 1px solid red;

      display: flex;
      height: 100%;
      width: 100%;
      // margin-left: 10px;
      justify-content: space-around;

      div {
        // outline: 1px solid red;
        // width: 96px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        position: relative;
        cursor: pointer;
        img {
          margin-right: 5px;
          // outline: 1px solid red;
          width: 20px;
        }
        span {
          // outline: 1px solid red;
          display: flex;
          flex: 1;
          // overflow: hidden;
        }
      }
      div:hover {
        color: #f7931a;
      }
      .active {
        color: #f7931a;
        font-weight: 600;
      }
    }

    #Stablecoin {
      // outline: 1px solid red;
      // width: 140px;
      display: flex;
    }
  }

  //搜索框
  .querySearch {
    // outline: 1px solid red;
    background: #e7f8ff;
    position: relative;
    width: 320px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 0px;
    top: 120px;
    z-index: 99;
    padding-top: 10px;

    p
    // background: #000;
    ::v-deep .el-autocomplete {
      width: 90%;
    }
    ::v-deep .el-input__inner {
      border: 1px solid rgba(0, 0, 0, 0.2);
      padding-left: 55px;
      border-radius: 8px;
      background: #e7f8ff;
      width: 100%;
      // outline: 1px solid red;
    }
    .searchIcon {
      // outline: 1px solid red;
      position: absolute;
      top: 23px;
      left: 256px;
      z-index: 99;
      width: 20px;
    }
    .starBox {
      position: absolute;
      top: 22px;
      left: 45px;
      z-index: 99;
      display: flex;
      justify-content: center;
      // align-content: center;
      // outline: 1px solid red;
      width: 50px;
      .close {
        color: #888;
        font-size: 13px;
        cursor: pointer;
      }
      .close:hover {
        color: #f7931a;
      }
    }
  }

  // .queryShow{
  //   display: block;
  // }

  // .noQueryShow{
  //   display: none;
  // }
}
.expandIcon {
  // outline: 1px solid red;
  width: 20px;
  z-index: 99;
  height: 100%;
  // background: red;
  position: absolute;
  right: 0px;
  // background: #f7931a;
  cursor: pointer;

  .sideIcon {
    font-size: 25px;
    font-weight: 600;
    // color: #f7931a;
    cursor: pointer;
    color: rgba(56, 61, 113, 0.4);
    margin-left: 15%;
    position: absolute;
    right: 0px;
    top: 500px;
  }
}

//每一项导航item
.navItem {
  display: flex;
  // outline: 1px solid red;
  align-items: center;
  // .el-rate{
  //   outline: 1px solid red;
  //   width: 30%;

  // }
  span {
    margin-left: 5px;
  }
}
.el-menu {
  height: 100%;
  // padding-top: 131px;
  // background: red;

  // margin-top:131px ;
  border: none;

  background-color: transparent;

  //  background-image: linear-gradient(
  //   to bottom,
  //   rgba(231, 248, 255, 1),
  //   rgba(231, 248, 255, 1),
  //   rgba(231, 248, 255, 0.4)
  // );
}

::v-deep .el-rate__icon {
  //星星图标
  font-size: 15px !important;
  margin: 0px;
}
.content {
  margin-left: 20px;
  font-weight: 600;
}
.content1 {
  font-weight: 600;
  margin-left: 2px;
}
.typeStyleT1 {
  // color: rgb(104, 113, 152);
  color: #f7931a;
  display: inline-block;
  vertical-align: middle;
  /* outline: 1px solid red; */
  background: rgba(247, 147, 26, 0.1);
  vertical-align: middle;
  width: 20px;
  height: 20px;
  line-height: 20px;
  font-size: 0.75rem;
  font-weight: bold;
  overflow: hidden;
  border-radius: 4px;
  text-align: center;
  letter-spacing: -1px;
  white-space: nowrap;
  text-transform: capitalize;
}
.el-submenu {
  // background-image: linear-gradient(
  //   to bottom,
  //   rgba(231, 248, 255, 1),
  //   rgba(231, 248, 255, 1),
  //   rgba(231, 248, 255, 0.9)
  // );
}
.el-menu-item {
  // background-image: linear-gradient(
  //   to bottom,
  //   rgba(231, 248, 255, 1),
  //   rgba(231, 248, 255, 1),
  //   rgba(231, 248, 255, 0.9)
  // );
}
.el-submenu .el-menu-item {
  white-space: nowrap;
  // text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  display: block;
  // background-image: linear-gradient(
  //   to bottom,
  //   rgba(231, 248, 255, 1),
  //   rgba(231, 248, 255, 1),
  //   rgba(231, 248, 255, 0.9)
  // );
  position: relative;
}
.el-submenu .el-menu {
  background-color: transparent;
}
//导航hover效果
.el-submenu .el-menu-item:hover {
  // background: #383d71;
  transition: opacity 0.2s ease-in-out;

  // padding: 2px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0px 3px 5px 4px rgba(0, 0, 0, 0.05);
}
.el-menu-item:hover {
  // background: #383d71;
  transition: opacity 0.2s ease-in-out;

  // padding: 2px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0px 3px 5px 4px rgba(0, 0, 0, 0.05);
}

.router-link-active {
  color: red;
}
.typeStyleT2 {
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  line-height: 20px;
  font-size: 0.75rem;
  font-weight: bold;
  overflow: hidden;
  border-radius: 4px;
  text-align: center;
  letter-spacing: -1px;
  white-space: nowrap;
  text-transform: capitalize;
  background: rgba(154, 96, 180, 0.1);
  color: rgba(154, 96, 180, 1);
}
.typeStyleT3 {
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  line-height: 20px;
  font-size: 0.75rem;
  font-weight: bold;
  overflow: hidden;
  border-radius: 4px;
  text-align: center;
  letter-spacing: -1px;
  white-space: nowrap;
  text-transform: capitalize;
  background: rgb(250, 233, 237);
  color: rgb(254, 109, 145);
}
/* ---------搜索框----------- */
// .choose{
//   position: relative;

// }
// .img{
//   position: absolute;
//   top:5px;
//   left:0px
// }
.menuItem {
  overflow-x: auto !important;
  // background: rgba(231,248,255, 0.3) !important;
}
// .scrolling-textBox { 
  
//     width: 200px;
//     overflow: hidden;
//     white-space: nowrap;
//     position: relative;
//     // text-overflow: ellipsis;
//     // padding: 20px;
//     // background: red !important;
//     outline: 1px solid red;
//   }
  
// .scrolling-text:hover{
//   position: absolute;
  
//   animation: marquee 5s linear infinite;
// }

// @keyframes marquee {
//   // 0% { transform: translateX(0%); }
//   // 100% { transform: translateX(-100%); }


//   0% { left: 100%; }
//     100% { left: -100%; }
// }



.menuItem::-webkit-scrollbar {
  display: none;
}
.searchBOX {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 100px;
  left: 0px;
  z-index: 99;
  background: #fff;
  padding: 10px 0px;
  margin: 0 auto;
  width: 315px;
  // outline: 1px solid red;
}

.dark-select {
  width: 100%;
  height: 60px;
  background: #fff;
  // border-radius: 5px;
  margin: 10px 0px;
  display: inline-block;
  // position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  // top: 50px;
  // //  top: 200px;
  // left: 0px;
  // z-index: 99;
  // background: gold;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  // outline: 1px solid red;

  .el-select-dropdown__item {
    line-height: 30px;
    height: 30px;
    // background: rgba(231,248,255, 0.3) !important;
  }

  .el-select .el-input .el-select__caret.el-icon-::before {
    content: "\e790";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  // 修改input默认值颜色 兼容其它主流浏览器
  input::-webkit-input-placeholder {
    // color: rgba(255, 255, 255, 0.60);
    color: rgba(0, 0, 0, 0.4);
  }
  input::-moz-input-placeholder {
    // color: rgba(255, 255, 255, 0.60);
    color: rgba(0, 0, 0, 0.6);
  }
  input::-ms-input-placeholder {
    // color: rgba(255, 255, 255, 0.60);
    color: rgba(0, 0, 0, 0.6);
  }
  // input框
  .el-select,
  .el-input,
  .el-input__inner {
    // background-color: rgba(0, 0, 0, 0.3);
    background-color: rgba(255, 255, 255, 0.1);
    // background: gold;
    z-index: 99;
    // background-color: #ccc;
    // color: rgba(255, 255, 255, 0.50);
    // color: #fff;
    // border: 1px solid #000;
    // outline: 1px solid #000;
    outline: none;
    // border: none; // 去掉边框
    // border-color: "#000";// 默认边框的颜色
    // text-align: left;
    // border-radius: 4px;
  }

  // 选中时边框颜色
  // .el-input__inner:focus{
  //       border-color: "#000" !important;
  //   }

  // 鼠标悬浮时 input框颜色
  .el-input__inner:hover {
    background-color: rgba(0, 0, 0, 0.3);
  }

  // input框 右侧的箭头
  //  .el-select .el-input .el-select__caret {
  //         color: rgba(255, 255, 255, 0.50);
  //     }

  // option选项 上面的箭头
  // .el-popper[x-placement^="bottom"] .popper__arrow::after {
  //         // border-bottom-color: rgba(43, 45, 55, 0.80);
  //         // border-bottom-color: rgba(0, 0, 0, 0.10);
  //         //  background: rgba(0, 0, 0, 0.2);
  //         // z-index: 9999;
  //     }
  // .popper__arrow {
  //         border: none;
  //     }
  // option选项 最外层
  .el-select-dropdown {
    // border: none !important;
    // background: rgba(43, 45, 55, 0.80) !important;
    // background: rgba(0, 0, 0, 0.2) !important;
    // background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.2);
    z-index: 9;
  }
  // option选项 文字样式
  .el-select-dropdown__item {
    // color: rgba(255, 255, 255, 0.50) !important;
    // color: rgba(0, 0, 0, 0.50) !important;
    // color: #000;
    z-index: 9;
    font-size: 12px;
  }
  .el-select-dropdown__item.selected span {
    // color: rgba(255, 255, 255, 0.80) !important;
    //  color: rgba(0, 0, 0, 0.50) !important;
    font-size: 12px;
    z-index: 9;
  }
  // 移入option选项 样式调整
  // .el-select-dropdown__item {
  //   height: 20px;
  //   margin-top: 10px;
  // }
  // // .el-select-dropdown__item.hover {
  //   // background-color: rgba(255, 255, 255, 0.06);
  //   // background-color: #d2d6e8;

  //   // color: rgba(255, 255, 255, 0.60) !important;
  //   z-index: 9999;
  // }

  // 下拉框垂直滚动条宽度
  // .el-scrollbar__bar.is-vertical {
  //        width: 10px;
  //        top: 2px;
  //    }
  // 下拉框最大高度
  //  .el-select-dropdown__wrap {
  //        max-height: 200px;
  //    }
  .label {
    margin-left: 10px;
  }
  .selectedImg {
    width: 18px;
    position: absolute;
    top: 37px;
    left: 68px;
    z-index: 999;
    // outline: 1px solid red;
  }
}
// .querySearch {
//   // border: 1px solid red ;
//   height: 40px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   background: #fff;
//   position: fixed;
//   left: 0px;
//   top:0px
// }
.searchIcon {
  position: absolute;
  left: 0px;
  cursor: pointer;
}

// 权限提示遮罩
.loginMain {
  z-index: 9999 !important;
  position: fixed;
  top: 60px;
  right: 0px;
  width: calc(100vw - 320px);
  height: 100vh;
  // outline: 1px solid red;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  backdrop-filter: blur(5px); //模糊遮罩效果
  padding-top: 20%;
  p {
    // color: rgba(255, 255, 255, 0.8);
    color: #000;
    font-weight: 600;
    font-size: 20px;
    // color: #000;
  }
  .lodinMaskBox {
    // outline: 1px solid red;
    display: flex;
    justify-content: space-around;
    // width: 100%;
  }
  .clickTag {
    height: 40px;
    line-height: 40px;
    display: inline-block;
    // outline: 1px solid red;
    padding: 0px 30px;
    cursor: pointer;
    // margin-left: 150px;
    font-size: 14px;
  }
  .clickTag:hover {
    background: rgba(247, 147, 26, 0.3);
  }
}

.authorityMask ::v-deep .v-modal {
  // background: rebeccapurple;
  position: fixed;
  top: 0px;
  left: 15%;
  right: 0px !important;
  width: 85%;
  // opacity: 0;

  background: rgb(0, 0, 0);
}
.UserLevel {
  color: #f7931a;
}
</style>

<style lang="scss">
// ::v-deep .el-menu .el-menu-item:hover {
//   // outline: 0 !important;
//   // color: #2e95fb !important;
//   // background: linear-gradient(270deg, #f2f7fc 0%, #fefefe 100%) !important;
//   // background:#000 !important;
// }
// ::v-deep
//   .el-menu
//   .el-submenu:nth-of-type(2)
//   .el-submenu
//   .el-menu-item.is-active {
//   color: #2e95fb !important;
//   background-color: rgba(0, 0, 0, 0.6) !important;
// }
// .el-submenu ::v-deep .el-submenu__title:hover {
//   color: #2e95fb !important;
//   background: linear-gradient(270deg, #f2f7fc 0%, #fefefe 100%) !important;
// }

//导航选中的颜色
// .el-menu-item.is-active {
//   color: #383d71 !important;
//   color: #f7931a !important;
//   font-weight: 600;
//   // background: rgba(0,0,0, 0.5) !important;
//   background: #effaff !important;
// }

.choose .el-input__inner {
  padding-right: 0px;
  padding-left: 30px;
}
.el-submenu__title {
  overflow: hidden;
  overflow-x: auto;
}
.el-submenu__title::-webkit-scrollbar {
  display: none;
}

// ::v-deep .el-menu .activeCorlor .el-submenu .el-submenu .el-menu-item.is-active {
//   background-color: rgba(0, 0, 0, 0.6) !important;
//   color: #fff !important;
// }
// ::v-deep .independentSubmenu > .el-menu-item.is-active{
//    background-color: rgba(0, 0, 0, 0.6) !important;
//   color: #fff !important;
// }\
.star {
  font-size: 30px;
  color: #f7931a;
}

.el-menu .el-menu--inline {
  background-color: transparent;
}

.custom-dropdown-menu2{
  .el-dropdown-menu__item{
    color: #fff ;
    font-size: 12px;
  }


 
} 
.el-popper .popper__arrow, .el-popper .popper__arrow::after{
  display: none 
}

</style>